export default {
  languageType: "ur",
  lang: "snd",
  welcome: "ڀلي ڪري آيا",
  select_your_language: "پنھجي زبان کي چونڊيو",

  purany_reg_ko_choren: "پرائي رجسثرکي ڇڏيو",
  ab_saara_hisaab_phone_pei: "سب حساب فون تي ڪيو",
  lets_get_started_for_free: "اچو ھاڻي مفت م شروعات ڪيو",
  get_started: "شروع ڪيو",
  login: "لوڱن",
  coming_soon: "جلدي اچي رهيو آهي",

  business_updated_success: "بزنس جو نالو اپڊيت ٿي ويو آھي",

  phone_number_placeholder: "موبائل نمبر",
  whats_your_phone_number: "توھان جو موبائل نمبر ڇا آھي",
  we_will_send_you_verification_code: "اسان توھان کي تصديق ڪري ڪوڊ موڪليون ٿا",
  resend_code_in: "Resend code in",
  enter_your_verification_code: "تصديقي ڪوڊ درج ڪيو",
  we_have_sent_a_verification_code_to: "اسان توھاڏي تصديقي ڪوڊ موڪليوآ",
  timeout_message:
    "توهان جي ڊيٽا کي بحال ڪرڻ ۾ مسئلو آهي ، مهرباني ڪري ٻيهر لاگ ان ڪريو",
  no_internet_please_login_again: "انٽرنيٽ نه ، مهرباني ڪري ٻيهر لاگ ان ڪيو",
  verification_code: "تصديقي ڪوڊ",
  i_didnt_get_a_code: "مونکي ڪوڊ ن مليو",
  invalid_code: "غلط ڪوڊ",
  resend_code: "ڪوڊ وري موڪل",
  having_trouble: "پريشاني ٿي ٿيو",
  call_us: "ڪال ملايو",
  view_report: "رپورٽ ڏسو",

  create_customer_to: "ٻيا گراهڪ ٺاھيو",
  to_give_udhaar: "اڌار ڏيو",
  create_customer: "گراهڪ ٺاھيو",
  how_to_add_a_new_customer: "نوان گراهڪ ڪين ٺاھيون؟",
  learn_how_to_use_oscar_udhaar: "اچو سکون اوسقر کي ڪيئن استمعال ڪبو آھي",
  watch_video: "وڊيو ڏسيو",

  customer_name: "گراهڪ جو نالو",
  enter_customer_name: "گراهڪ جو نالو داخل ڪيو",
  mobile_number: "موبائل نمبر",
  enter_mobile_number_optional: "موبائل نمبر داخل ڪيو(ضروري ناهي)",
  mobile_number_optional: "موبائل نمبر داخل ڪيو(ضروري ناهي)",
  enter_mobile_number: "موبائل نمبر درج ڪيو",
  save_and_exit: "محفوظ ڪيو ٻاھر نڪرو",

  // GIVE UDHAAR
  please_enter_correct_amount: "مهرباني ڪري صحيح رقم داخل ڪيو",
  give: "ڏيو",
  udhaar: "اڌار",
  UDHAAR: "اڌار",
  udhaar_book: "اڌار بڪ",
  accept: "واپس وٺو",
  PAYMENT: "پيسا",
  balance: "بقايا",
  add_payment: "رقم وجھو",
  udhaar_note: "نوٽ يا شيون شامل ڪيو (ضروري ناهي)",
  are_you_sure_you_want_to_delete_image:
    "ڇا توهان پڪ آهيو ته تصوير کي حذف ڪرڻ چاهيو ٿا؟",
  are_you_sure_you_want_to_exit: "چا توھان کي پڪ آھي ت توھان ٻھر نڪرڻ چاھيوٿا؟",

  //creatcustomer screen
  create_customertitle: "گراهڪ ٺاھيو",
  //credithistory screen
  date_and_time: "تاريخ ء وقت",
  payment: "پيسا",
  advance: "اڊوانس",
  balance_amount_credit_screen: "بقايا",
  sms: "ايس ايم ايس",
  reminder: "ياد ڪرايو",
  please_install_watsapp: "مھرباني ڪري واثس ايپ انسثال ڪيو",

  //todaykhata screen
  as_of_today: "ھاڻي تاينء",
  total_customer: "ڪل گراهڪ",
  net_balance: "ڪال بيلنس",
  total_udhaar_given: "ڪل اڌار ڏنو ڪل اڌار ڏنا ويا",
  total_advance: "ڪل ايدوانس",
  total_udhaar: "ڪل اڌار",
  share_oscar_udhaar_with:
    "پنھنجي دوستن ۽ مث مائثن سان شيئر ڪيو اوسقر اڌار جي ايپلي ڪيشن",

  //sharing screen
  share_on_whatsapp: "وائس ايپ تي موڪليو",
  more_options: "وڌيڪ اختيار",
  thankyou: "مھرباني",
  //home screen
  search_customers_by_name_or_phone_placeholder:
    "گراهڪ کي نالي يا نمبر سان ڳوليو",

  add_customer_details: "گراهڪ جي سڃي تفصيل ٻڌايو",
  name: "نالو",
  phone_number: "موبائل نمبر",

  total: "ڪل",
  select_date: "تاريخ چونڊيو",
  accept_payment: "پيسا واپس وٺو",
  give_udhaar: "اڌار ڏيو",
  balance_amount: "بقايا",

  enter_phone_placeholder: "موبائل نمبر",
  dont_have_account: " اڪائونٽ ناھي",
  // dont_have_account: "چا توھان وث اڪائونث ن آھي پنھجو اڪائونث ٺاھيو",

  //Drawer Component
  home: "ھوم",
  language: "زبان",
  logout: "لاگ آوٹ",
  urdu: "اردو",
  english: "انگریزی",
  business: "ڪاروبار",
  profile: "پرو فائل",
  settings: "سيٽنگ",
  business_card: "ڌنڌوڪارڊ",

  //filter options text
  sort_by_atoz: "A-Z ترتیب ڏيو",
  sort_by_ztoa: "Z-A ترتیب ڏيو",
  balance_due: "ببقا يا بیلنس",

  //note modal
  note: "نوٹ",

  promotions: "پرومشن",
  promotions_are_not_available_at_the_moment: "پرومشن ھن وقت موجود ناھي",
  customers_not_found: "گراهڪ نه لڌو",
  next: "اڳيان وڌو",
  are_you_sure_you_want_to_logout: "ڇاتوھان لاڱ آئوث ڪرڻ چاھيو ٿا؟",
  internet_is_required_for_sign_in: "انثرنيث ضروري آھي لاڱن جي لاء",
  internet_is_required_for_sign_up: " انثرنيث ضروري آھي ",
  add_your_first_entry: "پھنجي پھرين داخلا شامل ڪيو",
  mobile_no_is_already_registered: "ھي موبائل نمبر پھريو ئي استمعال ۾ آھي",
  customer_updated_successfully: "گراهڪ اپ ڊيٽ ٿي ويو آھي",
  transaction_updated_successfully: "ثرانزيڪشن اٽڊيث ٿي وئي آھي",
  transaction_added_successfully: "Transaction successfully added",
  no_customer_found_by_name: " ھن نالي سان ڪوئي گراهڪ ناھي",
  woulud_you_like: "ڇا توھان شامل ٿيڻ چا ھيو ٿا",
  add_user: "گراهڪ ٺاھيو",
  added_on: "تاريخ ۾ شامل ٿيو",
  user_not_found_create_an_account: "معاف ڪجو ھي اڪاوءنث موجود ناھي",
  verification_code_has_been_sent: "اسان توھاڏي تصديقي ڪوڊ موڪليوآھي",
  this_number_associate_with_another_customer:
    "ھي موبائل نمبر پھريوئي استعال ۾ آھي",
  no_customer_found: " ھن نالي سان ڪوئي گراهڪ ناھي, شامل ڪيو",

  //edit profile
  business_name: "ڪاروبار جو نالو",
  business_name_label: "ڪاروبار جو نالو",
  business_name_placeholder: "پھنجي دڪان جو نالو لکو",
  update: "اپ ڊيث",
  free_sms_bheje: "مفت ايس ايم ايس موڪلڻ جي لا۽ گراڪ جو فون نمبر وجھو",
  business_name_cannot_be_empty: "ڪاروبار جو نالو خالي نٿوٿي سگھي",
  update_customer: "اپ ڊيث گراهڪ",
  business_category_is_required: "ڪاراري قسم جي ضرورت آهي",
  business_category_label: "ڪاراري قسم",

  //view_customer_profile
  customerprofileheading: "گراهڪ جي پروفائل",
  do_you_want_to_delete: "گراهڪ کي ختم ڪرڻ چاھيون ٿا",
  cancel: "نه",
  yes: "ھا",
  no: "نه",
  delete_customer: "ڊليث گراهڪ",
  delete_supplier: "Delete supplier",
  customer_number: "فون نمبر",
  transaction_sms: "ٽرانزيڪشن ايس ايم ايس",

  //Account Statment Screen
  advance_acc: "اڊوانس",
  due_acc: "بقايا",
  customer: "گراهڪ",
  transactions: "ٽرانزيڪشن",
  transactions_type: "Transactions type",
  account: "اڪاوءنث",
  transaction_statement: "Transaction statement",
  account_statement: "اڪاوءنث اسثيثمنث",
  manage_your_ledger:
    "وقت جي بچت ۽ آمدني ۾ ۳ دفعا اضافو ڪرڻ جي لاء پنھجي لين دين کي اڌار ايپ جي اندر محفوظ ڪيو",
  date_select: "تاريخ چونڊيو",
  today: "اڄ",
  yesterday: "ڪالهه",
  last_seven_days: "گزريل ست ڏينھن",
  last_thirty_days: "آخري ٽي ڏينھن",
  date_acc: "تاريخ",
  filter_options: [
    "اڄ",
    "ڪالهه",
    "گزريل ست ڏينھن",
    "آخري ٽي ڏينھن",
    "پوئين مھيني",
    "ھروقت",
    "ختم ڪيو",
  ],

  //Edit Transactions Screen
  udhaar_amount: "اڌار رقم",
  payment_amount: "ادائيگي جي رقم",
  edit_transaction: "ٽرانسڪشن ڊاھيو",
  enter_amount_trans: "رقم لکيو",
  add_note_trans: "ڪنھق ب شيئ جو نلو لکو",
  do_you_want_to_delete_transaction: "ڇا توھان ھي ثراتر يڪشن ڊاھڻ چاھيو ٿا",
  customer_will_receive_SMS:
    "گراهڪ کي ايڊيث ڪيل معلومات سان ايس ايم ايس ملي ويندس",
  transaction_deleted: "ثرانزيڪشن ڊليث ٿي وئي",
  delete_transaction: "ڊليث ثرانزيڪشن ",
  save: "محفوظ",

  //backup screen
  backup: "بيڪ اپ",

  oscar_udhaar_backs_up_your_data_twice_a_day_automatically:
    "اوسقر اڌھار توھان جو بيڪ اپ ڏينھن م ۲ چکر کڻندي آھي",

  in_case_app:
    "اگر ايپ ڊيلتث ٿي وڃي ٿي ت آسقر اڌار کي ٻيھر ڊاوءن لوڊ ڪري پنھجو نمبر وجھي استمعال ڪيو توھان جو پراڻو خاتو واپس اچي ويندو",
  easy_safe_reliable: "آسان محفوظ ڪابل اعتماد ",
  last_backup_time: "آخري بئڪ اپ وقت",
  backup_success: "بئڪ اپ ڪامياب",
  backup_now: "ھاڻي بيڪ اپ وٺو",
  backup_not_successful: "بئڪ اپ ن ٿي سگھيو",
  data_not_backup:
    "توهان جي ڊيٽا مڪمل اپڊيٽ نه آهي. مهرباني ڪري توهان جي ڊيٽا کي اپڊيٽ",
  uploading_your_backup_please_wait: "پنھجو بئڪ اپ ڪندي انتظار ڪيو ",
  restoring_your_backup_please_wait: "پنھنجي ڊيثا کي بحال ڪيو",
  uploading: "اپ لوڊنگ",
  restoring: "بحالي",
  name_can_not_be_empty: "نالو خالي نه ٿو اچي",
  contact_list: "فون جو ڪتاب",
  add_new_customer: "نئون ڪسٽم شامل ڪيو",

  // Business Card
  business_category: "ڪاروبار ڪيثگري",
  address: "ايڊريس",
  enter_address_optional: "ايڊريس لکھو",
  other_info: "وڌيڪ معلومات",
  ohter_info_placeholder: "اي ميل معلومات ء نالو",
  email: "اي ميل",
  email_placeholder_optional: "اي ميل لکو",
  about_us: "معلومات",
  about_us_placeholder_optional: "معلومات لکو",
  contact_name: "نالو",
  contact_name_placeholder_optional: "نالو لکڻو",
  create_and_share_business_card: "پنھجو بذنس ڪارڊ ٺاھيو ۽ شيئر ڪيو",
  business_name_is_required: "ڪاروبار جو نالو ضروري آھي",
  share_business_card: "شيئر بزنس ڪارڊ",
  phone_number_is_required: "فون نمبر ضروري آھي",
  address_is_required: "ايڊريس ضروري آھي",
  email_is_required: "اي ميل ضروري آھي",
  about_us_is_required: "معلومات ضروري آھي ",
  contact_name_is_required: "نالو ضروري آھي",
  other_info_is_required: "مھرباني ڪري ھن فيلڊ کي پورو ڪيو ",
  email_business_card: "اي ميل:",
  address_business_card: "ايڊريس:",
  more_options_business_card: "وڌيڪ اختيار",
  add_business_name: "تجارتي نالو شامل ڪريو",
  udhaar_due: "باقي اڌار",
  number_of_customers: "ڪل گراهڪ",
  download: "ڊائون لوڊ",
  select_mobile_network_placeholder: "موبائل نيٽورڪ چونڊيو",
  mobile_network: "موبائل نيٽ ورڪ",
  phone_number_format: "موبائل نمبر هن طرح هئڻ گهرجي ، مثال طور 03001234567",
  phone_number_length: "موبائل نمبر 11 عددن هجڻ گهرجي (مثال طور 03xx1234567)",
  network_required: "موبائل نيٽ ورڪ گھربل آھي",
  telenor: "ٽيلي نار",
  jazz: "جاز",
  ufone: "یوفون",
  zong: "زونگ",
  scom: " ايس کوم",
  select_business_category: "ڪاروباري ڪيٽيگري چونڊيو",
  camera: "ڪئميرا",
  gallery: "گيلري",
  delete: "ڊليث",
  photo_added: "تصوير شامل آهي",
  please_select_your_business_category: "ڪاروباري قسم جو انتخاب ڪيو",
  upload_from: "کان اپ ڊيٽ ڪاريون",
  take_photo_with: "سان فوٽو وٺو",
  internet_connection_is_required: "انٽرنيٽ ڪنيڪشن گهربل آهي",
  no_internet: "انٽرنيٽ ڪنيڪشن گهربل آهي",
  internet_to_view_image: "تصوير ڏسڻ لاءِ انٽرنيٽ ڪنيڪشن گھربل آهي",
  internet_to_upload_image: "تصوير اپ لوڊ ڪرڻ لاءِ انٽرنيٽ ڪنيڪشن گهربل آهي",
  transaction_saved: "ٽرانزيڪشن محفوظ ٿي وئي",
  message_sent: "ايس ايم ايس موڪليو ويو آھي",
  udhaar_balance: "اڌار بيلنس",
  advance_balance: "ايڊوانس بيلنس",
  payment_reminder: "پیمنٹ ریمائنڈر",
  eid_card: "عيد ڪارڊ",
  send_eid_card: "عيد ڪارڊ موڪليو",
  share_eid_card: "عيد ڪارڊ شيئر ڪريو",
  create_share_eid_card: "پنهنجو عيد ڪارڊ ٺاهيو ۽ شيئر ڪريو",
  greeting_salutation: "سلام / آداب عرض",
  greeting_placeholder: "سلام داخل ڪيو",
  greeting_required: "سلام گهربل آهي",
  eid_message: "عيد جو پيغام",
  eid_message_placeholder: "عيد جو پيغام داخل ڪريو",
  message_required: "عيد جو پيغام گھربل آهي",
  signature: "دستخط",
  signature_placeholder: "دستخط داخل ڪريو",
  signature_required: "دستخط گهربل آهي",
  send_card_to_customers: "پنهنجي گراهڪن لاءِ مفت عيد ڪارڊ موڪليو",
  greeting_message_requried: "سلام ۽ پيغام لازمي آهن",
  set_collection_date: "جمع ڪرائڻ جي تاريخ مقرر ڪريو",
  collection_date: "جمع ڪرائڻ جي تاريخ",
  select_collection_date: "جمع ڪرڻ جي تاريخ چونڊيو",
  collection_sub_heading:
    "ايس ايم ايس يادگيري توهان جي گراهڪ ڏانهن موڪلي ويندي",
  collection_sub_heading_2:
    "ايس ايم ايس ياد ڏياريندڙ چونڊ واري تاريخ تي توهان جي گراهڪ ڏانهن موڪلي ويندي",
  clear: "صاف",
  collection_due: "جمع ڪرائڻ جو سبب",
  sms_will_be_sent: "آٹومیٽڪ ايس ايم ايس الرٽ موڪلي ويندي",
  remind: "ياد ڏياريندڙ",
  collection: "جمع ڪرڻ",
  payment_due_today: "ادائگي اڄ ٿيڻ واري آهي",
  past_due: "ماضي جي ادائيگي",
  five_days: "5 ڏينهن",
  ten_days: "10 ڏينهن",
  fifteen_days: "15 ڏينهن",
  next_month: "ايندڙ مهيني",
  request_payment: "ادائيگي جي درخواست ",
  send_via_whatsapp: " وا ٽس ایپ جي ذريعي موڪليو",
  send_via_sms: "ايس ايم ايس جي ذريعي موڪليو",
  call_customer: "گراهڪ کي ڪال ڪريو",
  independence_day_tag: "2 هزار روپيا کٽڻ جي لاءِ 14 آگسٽ جي وڊيو کي شيئر ڪريو",
  independence_day_video: "آزادي واري ڏينهن جي ويڊيو",
  create_share_independence_video:
    "آزادي واري ڏينهن جي ويڊيو ٺاهيو ۽ شيئر ڪريو",
  share_facebook: "فيس بوڪ تي شيئر ڪريو",
  please_install_facebook: "مهرباني ڪري فيسبوڪ انسٽال ڪريو",
  request_dues: "خبرون",
  restore_error:
    "توهان جي ڊيٽا مڪمل طور تي بحال نه ٿي سگھي ، مهرباني ڪري ٻيهر لاگ ان ٿيو",
  record_video_message: "هڪ وڊيو پيغام ريڪارڊ ڪيو",
  record_video: "وڊيو رڪارڊ ڪريو",
  video_message_1: "پنهنجن دوستن کي آزادي جو پيغام رڪارڊ ڪيو",
  video_message_2: "نياپو رڪارڊ ڪيو",
  video_sub_message: "20-40 سيڪنڊ وڊيو ٺاهيو ۽ 2000 روپيا کٽيو",
  follow_these_steps: "انهن مرحلن تي عمل ڪريو",
  step_1: "ويڊيو شيئر ڪريو پنهنجي ٽائم لائن تي",
  step_2: "ٽيگَ شامل ڪريو #AzadiStar #UdhaarApp #Azadi2020",
  step_3: "پنھنجي دوستن سان شيئر ڪريو",
  step_4: "سڀني کان وڌيڪ شيئرز ۾ 2 هزار روپيا جو انعامي انعام ملندو",
  step_5: "پنھنجا ويچار ڪمينٽ ۾ شيئر ڪريو",
  download_report: "ڊائون لوڊ رپورٽ",
  send_free_sms: "مفت ايس ايم ايس موڪليو",
  aap_ne: "توهان",
  liye_hain: "لاءِ آهن",
  info: "معلومات",
  send_sms: "ايس ايم ايس موڪليو",
  sedf_sms2: "ايس ايم ايس موڪليو",
  not_now: "اڃان نه",
  quotes: [
    "مضبوط آپ کا نام ہے",
    "یقین کریں آپ یے کر سکتے ہو",
    "آج کر کے دکھا دو",
    "اپنے آپ پہ فخر کرو",
    "ایسا کچھ نہیں جو نا ہوسکے",
    "تم کرسکتے ہو اور یہ جانتے ہو",
    "وقت کی قدر کرو",
    "ہمت جوتائو اور زور لگاو",
    "صرف کوشش نہیں ، کر دیکھاؤ",
    "آگے بڑھو",
    "سر اوٹھا کے چلو",
  ],
  trusted_by:
    "سموري پاڪستان م 5.1+ ملين کان وديڪ ڪاروبار ڪرڻ وارا ماڻھون بھروسو ڪندا آھن",
  by_continuing:
    "اڳيان وڌڻ لاء توھان متفق آھيو اسان جي سروس جي شرطن ۽ حفاظت سان",
  terms_of_services: "خدمات کی شرائط",
  privacy_policy: "حفاظتی پالیس",
  other_category: "ٻيون قسمون",
  enter_other_category: "ٻيون قسمون جو نالو",
  add_customer: "گراهڪ بڻجو",
  payments: "جمع",
  udhaars: "اڌار",
  send_via: "جي ذريعي موڪليو",
  whatsapp: "وائس ایپ",
  report: "رپورٽ",
  customer_statement: "گراهڪ اسثيثمينث",
  ledger_ready: "توهان جوڪھاتو تيار آهي",
  have_a_wonderful_day: "توهان جو ڏينهن سٺو گذري",
  having_trouble_contact_us: "مسئلو ٿي رهيو آهي؟ اسان سان رابطو ڪريو",
  loading_your_data: "ڪلائوڊ بيڪ اپ کان توهان جي ڊيٽا لوڊ ڪندي",
  data_loaded: "ڊيٽا لوڊ ٿي ويو.ڪاتو سيٽ ٿي رهيو آهي",
  awsome_phone_verified: "بهترين توهان جو موبائل نمبر تصديق ٿيل آهي",
  businesss_will_be_displayed:
    "توھان پنھنجن ڌنڌي جي نالي سان پنھنجو گراهڪ مفت ايس ايم ايس موڪلي سگھو ٿا.",
  logged_in_from_another_device:
    "توهان ٻئي ڊوائيس کان اڌار ايپ ۾ لاگ ان ڪيو آهي.",
  device_has_been_logged_out:
    "هي سکيا ڊوائيس لاگ آئوٽ ٿيل آهي.هن ڊيوائس تي لون ايپ استعمال ڪرڻ لاءِ ”هتي استعمال ڪريو“ جي بٽڻ کي دٻايو.",
  use_here: "هتي استعمال ڪريو",
  grow_business_with_udhaar: "اڌار ايپ سان گڏ پنهنجو ڪاروبار واڌايو",
  enter_khata_amount: "ڪھاتا رقم داخل ڪريو",
  share_details_with_sms: "تفصيلات مفت ايس ايم ايس سان شيئر ڪريو",
  play_and_win_cash: "کوئز کھیلیں اور نقد انعام جیتیں۔",
  play_now: "اب کھیلیں",
  udhaar_quiz: "ادھار کوئز",
  play_and_earn_gifts: "کھیلیں اور تحائف  کمائیں",
  how_to_play: "کھیلیں اور 1000 روپئے جیتیں",
  trivia_instructons_1: "سب سوالوں کے صحیح جواب دیں",
  trivia_instructons_2: "کوئز کا وقت ہوگا 60 سیکنڈ",
  trivia_instructons_3: "1000 روپیہ جیتیں ہر ہفتے",
  start_quiz: "کوئز شروع کریں",
  quiz_timings: "کوئز کا ٹاۂم ہر روز 12PM - 4PM ",
  help: "مدد",
  question: "سوال",
  congrats_you_won: "مبارک ہو! آپ جیت گئے",
  sorry_you_didnt_win: "معذرت ، آپ جیت نہیں سکے",
  missed_by_1: "افوہ ، صرف 1 غلط جواب سے  رہ گے",
  lucky_draw_will_be_announced:
    "لکی ڈرا میں جیتنے والے کا اعلان جمعہ کو 4PM پر کیا جائے گا",
  share_on_facebook_to_win:
    "جیتنے کے امکانات بڑھانے کے لئے فیس بک پر شیئر کریں۔",
  IA_next_time: "کل اگلے کوءز میں شامل ہو کر کامیابی حاصل کریں",
  new_quiz_tomorrow: "اگلا کوئز کل شروع ہوگا",
  share: "شۂیر",
  back_to_home: "واپس ہوم پیج پر",
  contact_us: "ہم سے رابطہ کریں",
  terms_and_conditions: "شرائط و ضوابط",
  trivia_term_1: "1. کوئز آسکر کی جینب سی آرگنائز کیا گیا ہے",
  trivia_term_2:
    "2. کوئز میں شامل ہونے کے لیے شرکاء کو تمام شرائط و ضوابط کو  فالو کرنا لزمی ہوگا",
  trivia_term_3: "3. کوئز مائی انٹری کے کوئی چارجز نہیں ہیں",
  trivia_term_4: "4. کوئز دوپہر 12 سے شام 4 بجے تک کھیلا جا سکتا ہے",
  trivia_term_5: "5. جوابات شرائط و ضوابط کے مطابق قبول کیے جاۂیں گے",
  trivia_term_6: "6. نا مکمال یا برے غیر مطلوب اندراجات نہی قبول ہونگے",
  trivia_term_7: "7. کوئز ہمیشہ جمعہ کو شروع ہوگا اور جمعرات کو ختم ہوگا",
  trivia_term_8:
    "8. جیتنے والوں کے نام کا اعلان ہفتہ وار بنیاد پر جمعہ کو کیا جائے گا",
  trivia_term_9: "9. اودھار ایپ کے تمام رجسٹرڈ صارف کوئز میں حصہ لے سکتے ہیں",
  quiz_submit_karnai_ke_baad: "کوئز جمع کرانے کے بعد",
  after_submit_1: "1. جیتنے والی رقم 1000 روپے ہے",
  after_submit_2:
    "2۔ روزانہ کی بنیاد پر 3 سوالوں کا جواب دینا ہوتا ہے اور اس میں 1 اندراج شمار ہوگا۔ جن لوگوں نے ان 3 سوالات کے تمام صحیح جوابات دیئے وہ اگلے مرحلے کے لئے کوالیفائی کرسکیں گے۔",
  after_submit_3:
    "3. ایک ہفتہ میں زیادہ سے زیادہ صحیح جوابات کے جیتنے کے زیادہ امکانات",
  after_submit_4: `"4. جیتنے والے کے نام کے اعلان ہونے کے بعد ، فاتح کو یہ تفصیلات شیئر کرنا ہوں گی:
        a. نام
        b. رابطہ نمبر
        c پتہ
        d. این آئی سی نمبر
        e. تصویر (لاضمی نہیں)`,
  after_submit_5:
    "5. جیتنے والا انعام فاتح کے نام کے اعلان کے 3 سے 4 دن کے اندر دیا جائے گا",
  after_submit_6:
    "6. کسی بھی غیر یقینی صورتحال میں آسکر فیصلہ آخری فیصلہ ہوگا۔ اور اس فیصلے پر مزید بحث نہیں کی جائے گی۔",
  after_submit_7:
    "7. کسی بھی صورت میں ، آسکر کوئز کو منسوخ یا ملتوی کرسکتا ہے۔ جیتنے والی رقم میں بھی تبدیلی آسکتی ہے۔ آسکر کے لئے صارفین کو مطلع کرنا ضروری نہیں ہے",
  after_submit_8:
    "8. آسکر کو جیتنے والی رقم منسوخ کرنے کا حق ہے اگر یہ رقم کسی بھی غیر قانونی سرگرمی یا غیر اخلاقی طریقے سے استعمال کی جائے۔",
  after_submit_9:
    "9. کوئز کھیلنے کے لیے آپ آسکر کو اپنے نام اور شہر کا اشتراک کرنے کی اجازت دے رہے ہیں اگر آپ جیت جاتے ہیں۔",
  after_submit_10:
    "10۔ آسکر پیشگی اطلاع کے بغیر شرائط و ضوابط میں تبدیلی کرسکتا ہے",
  do_you_want_to_exit: "کیا آپ واقعی باہر نکلنا چاہتے ہیں؟",
  you_wont_be_able_to_play:
    "آپ آج دوبارہ کھیل نہیں سکیں گے۔ اگلا کوئز کل سے شروع ہوگا۔",
  enter_pin_to_use_udhaar: "ادھار ایپ کو استعمال کرنے کے لئے پن درج کریں",
  enter_pin_to_remove_pin: "سیکیورٹی کو ختم کرنے کے لئے پن درج کریں",
  set_new_udhaar_app_pin: "اودھار ایپ کا نیا پن سیٹ کریں",
  pin_did_not_match: "پن ٹھیک نہیں ہے",
  pin_lock_has_been_removed: "پن لاک ہٹا دیا گیا ہے",
  confirm_udhaar_app_pin: "ادھار ایپ پن کی تصدیق کریں",
  enter_pin: "پن سیٹ کریں",
  enter_pin_here: "Enter PIN here",
  udhaar_security: "ادھار سیکیورٹی",
  touch_sensor: "ٹچ سینسر",
  you_must_set_a_pin_first: "آپ کو پہلے ایک پن تیار کرنا چاہئے",
  remove_biometric: "بایومیٹرک کو ہٹا دیں",
  pincode: "پن کوڈ",
  set_a_4_digit_pincode: "4 ہندسوں کا پن کوڈ سیٹ کریں",
  enable: "آن کر دو",
  face_id: "چہرے کی شناخت",
  touch_id: "انگلی کی شناخت",
  biometrics: "بایومیٹرکس",
  app_lock: "ایپ لاک",
  data_not_backedup: "ڈیٹا کا بیک اپ نہیں لیا گیا",
  click_here: "یہاں کلک کریں",
  to_backup_your_data: "بیک اپ کیلئے ",
  backup_successful: "ڈیٹا بیک اپ ہوچکا ہے",
  select_account_statement_filter: "اکاؤنٹ اسٹیٹمنٹ فلٹر منتخب کریں",
  selected_filter: "منتخب فلٹر: ",
  custom: "اپنی مرضی کے مطابق",
  select_upcoming_date: "آنے والی تاریخ منتخب کریں",
  filter_error: "غلط فلٹر",
  dont_know: "پتہ نہیں",
  filter: "فلٹر",
  no_contact_permission_1: "کیا آپ اپنی فون بک سے روابط منتخب کرنا چاہیں گے؟",
  no_contact_permission_2: "ادھار ایپ کو اپنے رابطوں تک رسائی کی اجازت دیں۔",
  no_contact_permission_3: "اجازت دینے کے لئے یہاں کلک کریں.",
  collection_date_heading: "جمع تاریخ",
  pending: "باقی",
  upcoming: "انے والے",
  settled: "برابر",
  sort_by: "ترتیب",
  filter_name_az: "نام (A-Z)",
  filter_amount: "رقم",
  filter_amount_desc: "Amount Descending",
  filter_least_recent: "Least Recent",
  filter_most_recent: "سب سے حالیہ",
  filter_due_date: "اخری تاریخ",
  transaction_type: "ٹرانزیکشن کی قسم",
  default: "پہلے سے طے شدہ",
  apply: "ٹھیک ہے",
  all: "تمام",
  loading_your_contacts: "فون نمبرز لوڈ ہو رہے ہیں",
  udhaar_app_secure_lock: "ادھار اپلی کیشن محفوظ لاک",
  please_use_fingerprint_to_unlock_app:
    "براہ کرم ایپ کو غیر مقفل کرنے کیلئے فنگر پرنٹ کا استعمال کریں",
  show_finger: "انگلی دکھائیں",
  touch_the_fingerprint_sensor: "فنگر پرنٹ سینسر کو ٹچ کریں",
  wrong_pin: "غلط پن. آپ کے پاس",
  attempts_remaining: "کوششیں باقی ہیں",
  reset_pin: "پن ری سیٹ کریں",
  forgot_pin: "پن بھول گئے؟",
  your_udhaar_app_account_is_locked: "آپ کا ادھار ایپ اکاؤنٹ بند ہے",
  tap_here_to_use_finger_print_login:
    "فنگر پرنٹ لاگ ان کو استعمال کرنے کے لئے یہاں تھپتھپائیں",
  commission_earned: "حاصل کمیشن",
  customer_n: "صارف  #",
  easyload: "ایزی لوڈ",
  commission: "کمیشن",
  wallet: "والیٹ",
  give_easy_load: "ایزی لوڈ دیں",
  choose_network: "نیٹ ورک کا انتخاب کریں",
  earned: "کمائی",
  add_balance: "بیلنس شامل کریں",
  easy_load_by_udhaar: "ایزی لوڈ بذریعہ ادھار ایپ",
  earn_commission_with_udhaar:
    "ادھار ایپ کے ساتھ ایزی لوڈ پر 2.5 فیصد کمیشن تک کمائیں",
  easy_load_in_3_steps: "ایزی لوڈ 3 آسان طریقے سے",
  add_balance_to_wallet: "والیٹ میں رقم ڈالیں",
  enter_customer_number: "کسٹمر کا فون نمبر درج کریں",
  give_easy_load_earn_commission: "ایزی لوڈ دیں اور کمشن کمائیں",
  addBalance: "بیلنس شامل کریں",
  add_money_to_wallet: "والیٹ میں رقم ڈالیں",
  easy_paisa: "ایزی پیسہ",
  jazz_cash: "جاز کیش",
  ubl: "UBL",
  hbl: "HBL",
  easy_paisa_account: "ایزی پیسہ اکاؤنٹ",
  jazz_cash_account: "جاز کیش اکاؤنٹ",
  ubl_account: "UBL اکاؤنٹ",
  hbl_account: "HBL  اکاؤنٹ",
  account: "کھاتہ",
  accounts: "Accounts",
  mobile_number_label: "موبائل نمبر",
  number_verification_note:
    "نوٹ: موبائل نمبر کی تصدیق کے لئے OTP  کوڈ بھیجا جائے گا",
  amount_required: "رقم کی ضرورت ہے",
  easypaisa_pin_confirmation: "ایزی پیسہ پن کی تصدیق ",
  jazzcash_pin_confirmation: "جاز کیش پن کی تصدیق ",
  ubl_pin_confirmation: "UBL پن کی تصدیق ",
  hbl_pin_confirmation: "HBL پن کی تصدیق ",
  pin_confirmation: "پن کی تصدیق ",
  enter_otp_code: "OTP  کوڈ درج کریں",
  submit: "جمع کرائیں",
  has_been_added_to_wallet: "آپ کے والیٹ کی رقم میں اضافہ کردیا گیا ہے۔",
  you_can_use_the_balance:
    "اب آپ ریچارج اور ادائیگیوں کے لئے بیلنس کا استعمال کر سکتے ہیں",
  edit_information: "معلومات میں تبدیلی کریں",
  earn_money: "پیسہ کماؤ",
  b_card: "B.Card",
  play_quiz: "کوئز کھیلیں ",
  easy_load: "ایزی لوڈ",
  prepaid: "پری پیڈ",
  postpaid: "پوسٹ پیڈ",
  device: "ڈیوائس",
  no_packages_available: "پیکجز دستیاب نہیں ",
  recharge_details: "ریچارج تفصیلات دیکھیں",
  network: "نیٹ ورک",
  phone_number_small: "موبائل نمبر",
  feeAndTax: "فیس اور ٹیکس",
  no_charges: "کوئی چارجزنہیں ",
  total_amount: "کل رقم",
  pay_now: "اب ادا کریں",
  easyload_successful: "ایزی لوڈ کامیاب",
  phoneN: "موبائل  #:",
  sms_has_been_sent: "SMS اوپر نمبر پر بھیج دیا گیا ہے",
  edit_share_whatsapp: "ایڈٹ اور واٹس ایپ پر شیئر کریں",
  edit: "ایڈٹ ",
  marketing_in_easy_steps: "3  آسان مراحل میں مارکیٹنگ",
  choose_your_details: " تفصیلات میں سے انتخاب کریں",
  enter_your_details: "آپ اپنے تفصیلات درج کریں",
  share_details_whatsapp: "واٹس ایپ پر تفصیلات شیئر کریں",
  add_first_banner: "اپنا پہلا بینر لگائیں",
  offer: "50٪  کی چھوٹ کی پیشکش",
  best_quality_products: "مناسب قیمت پر بہترین معیار کی مصنوعات",
  shop_from: "دکان سے ",
  my_shop: "My Shop",
  enter_heading: "عنوان درج کریں",
  enter_description: "تفصیل درج کریں",
  description_placeholder: "بہترین معیار کی مصنوعات",
  enter_shope_name: "دکان کا نام درج کریں",
  share_store_banner: "شئیر سٹور بینر",
  edit_template: "ڈیزائن میں ترمیم کریں",
  invalid_amount: "غلط رقم",
  get_more_business: "فری مارکیٹنگ سے مزید کاروبار حاصل کریں",
  select_your_marketing_banner: "اپنے مارکیٹنگ کا بینر منتخب کریں",
  add_promotion_or_other_special_message:
    "پروموشنز یا دیگر خاص پیغام شامل کریں",
  share_with_friends_and_customers: "دوستوں اور کسٹمرکے ساتھ شیئر کریں",
  marketing: "مارکیٹنگ",
  more: "مزید",
  new: "نئی",
  to_take: "آپ نے لینے ہیں",
  to_give: "آپ نے دینے ہیں",
  total_taken: "آپ نے لیے ہیں",
  total_given: "آپ نے دیے ہیں",
  entry: "انٹری",
  entries: "انٹریس",
  given: "آپ نے دیے",
  taken: "آپ نے لیے",
  give_: "دیں",
  take: "لیں",
  your_business: "آپ کا کاروبار",
  create_new_business: "نیا کاروبار بناۂیں",
  switching_to_business: "{name} پر سوئچ ہو رہے ہیں",
  add_new_business: "نیا کاروبار بناۂیں",
  select_start_date: "شروع تاریخ",
  select_end_date: "آخری تاریخ",
  transaction: "ٹرانزیکشن",
  add_your_first_traansaction: "اپنا پہلا کھاتا بناۂیں",
  setup_your_invoice_transaction_with_us:
    "ہمارے ساتھ ٹرانزیکشن انوائس سیٹ اپ کریں",
  loading: "لوڈ کر رہا ہے",
  active_filter: "موجودا فلٽر",
  add_business: "کاروبار بناۂیں",
  logout_backup: "بيڪ اپ",
  logout_anyway: "بهرحال لاگ ان ٿيو",
  waiting_otp: "او ٽي پي ڪوڊ کي پاڻمرادو ڳولڻ جو انتظار ڪيو ويو",
  enter_code: "4 عدد ڪوڊ داخل ڪريو",
  call_me: "مونکي ڪال ڪريو",
  verify: "تصديق ڪريو",
  have_you_change_mobile_network:
    "ڇا توهان پنهنجو موبائل نيٽورڪ تبديل ڪيو آهي؟",
  select_network_to_rec_otp:
    "مهرباني ڪري پنهنجو نئون نيٽ ورڪ او ٽي پي حاصل ڪرڻ لاءِ چونڊيو",
  waiting_for_code: "ڪوڊ لاءِ انتظار ڪرڻ :",
  otp_call: "توهان ڪال تي او ٽي پي ڪوڊ ملندو.",
  no_filter_match: "ڪوبه گراهڪ توهان جي فلٽر معيار سان نه ملي",
  add_customer_and_maintain_udhaar:
    "گراهڪ ٺاهيو ۽ پنهنجو روزانو اڪائونٽ محفوظ ڪريو",
  manage_your_business:
    "اپنے کھاتا اور اپنے کاروبار کو چلائیں۔ یاددہانی بھیجیں ، ادائیگی وصول کریں۔ سب مفت۔",
  trusted_b_over: " 5.1+ ملين کان وڌيڪ ڪاروبار",
  trusted_b: "5.1+ ملين کان وديڪ ڪاروبار ڪرڻ وارا ماڻھون بھروسو ڪندا آھن",
  stat_using_udhaar_app: "قرض واري ايپ استعمال ڪرڻ شروع ڪريو",
  dont_ask: "ٻيهر نه پڇو",
  manage_daily_cash_transactions:
    "اپنے روزانہ کا کیش ، فروخت اور اخراجات کا نظام رکھیں",
  invoice_descp_1: "Tally cash balance in hand vs sales & expenses",
  invoice_descp_2: "آئٹم کی تفصیلات کے ساتھ کسٹم بل اور رسید بنائیں",
  invoice_descp_3: "ماہانہ اور روزانہ کی رپورٹیں ڈاؤن لوڈ کریں",
  cash_in: "ڪيش اِن",
  cash_out: "ڪيش آئوٽ",
  add_item: "آئٹم شامل کریں",
  change_date: "تاریخ تبدیل کریں",
  add_photo: "تصویر لگایں",
  add_note: "نوٹ ڈالیں",
  select_invoice_date: "انوائس کی تاریخ منتخب کریں",
  reset: "ری سیٹ کریں",
  enter_item_name: "آئٹم کا نام لکھیں",
  enter_item_placeholder: "جیسے آم",
  item_name_required: "آئٹم کا نام ضروری ہے",
  add_another_item: "اور آئٹم شامل کریں",
  invalid_quantity: "غلط مقدار",
  customer_list: "کسٹمر لسٹ",
  select_invoice_status: "انوائس اسٹیٹس کو منتخب کریں",
  paid: "ادا کیا",
  not_paid: "ادا نہیں کیا",
  select_payment_method: "ادائیگی کرنے کا طریقہ منتخب کریں",
  cash: "کیش",
  bank: "بینک",
  add_your_own: "اپنا شامل کریں",
  payment_method: "ادائیگی کا طریقہ",
  change_method: "طریقہ بدلیں",
  invoice: "انوائس",
  verified_by: "تصدیق شدہ",
  item_details: "آئٹم کی تفصیلات",
  qty: "Qty",
  // total_amount: 'کل رقم',
  made_with: "کے ساتھ بنایا گیا ",
  in: "اندر",
  out: "باہر",
  cash_out_amount: "کیش آؤٹ رقم",
  cash_in_amount: "آنے والی رقم",
  cash_in_placeholder: "آنے والی رقم ڈالیں",
  cash_out_placeholder: "کیش آؤٹ رقم ڈالیں",
  take_a_picture: "تصویر لو",
  upload_from_gallery: "گیلری سے اپ لوڈ کریں",
  take_photo_with_camera: "کیمرے سے فوٹو لے لو",
  more_items: "مزید آئٹم",
  transaction_successful: "ٹرانزیکشن کامیاب",
  cash_on_hand: "ہاتھ میں کیش",
  cashbook: "ڪيش ڪتاب",
  sales: "فروخت",
  expense: "اخراجات",
  bill: "بل",
  add_bill_to_contact: "کانٹیکٹ میں بل شامل کریں",
  automatically_add_credit_to_contact:
    "کیا آپ اس کانکٹ کے اکاونٹ میں یہ انٹری شامل کرنا چاہتے ہیں؟",
  // no: 'نہیں',
  quick_entry: "فوری انٹری",
  itemized_entry: "آئٹمائزڈ انٹری",
  // transaction_type: 'ٹرانزیکشن کی قسم',
  invoice_can_be_edited_cashbook:
    "انوائسز صرف کیش بک سے ایڈیٹ / ڈیلیٹ کی جاسکتی ہیں",
  delete_associated_invoices: "متعلقہ رسیدیں ڈیلیٹ کریں",
  do_you_want_to_delete_invoice:
    "کیا آپ اس کانٹیکٹ سے وابستہ رسیدیں ڈیلیٹ کرنا چاہتے ہیں؟",
  upload_photo: "تصویر اپلوڈ کریں",
  todays_balance: "آج کا بیلنس",
  delete_entry: "انٹری کو ڈیلیٹ کریں",
  credit_added_to_contact: "اس رابطے میں رقم شامل کردی گئی ہے",
  contact_via_whatsapp: "واٹس ایپ کے ذریعے رابطہ کریں",
  credit: "کریڈٹ",
  add_contact: "نمبر شامل کریں",
  share_your_promotions: "اپنی پروموشنز شیئر کریں",
  edit_sales: "ایڈٹ سیلز",
  edit_expense: "ایڈٹ خرچ",
  play_tutorial: "وڊيو ڏسو  ",
  see_help_tutorial: "وڊيو ڏسو  ",
  manage_cash_sale: "انتظام ، ڪيش ، وڪرو ۽ خرچ.",
  send_free_invoices: "مفت انوائس موڪليو.",
  send_free_promotions: "مفت پروموشنز موڪليو",
  send_free_promotions_to_customer: "گراهڪ کي مفت واڌارو موڪليو ۽ وڪرو وڌايو.",
  share_udhaar_app: "پنهنجي دوستن سان اردو ادب کي حصيداري ڪريو",
  earn_upto: "رپين تائين اٽو 45،000 / مهينو.",
  you_will_get:
    "توهان هر دوست لاءِ ڏهه روپيا وصول ڪندا سين جيڪا 2 الڳ ڏينهن تي 2 ٽرانسڪشن ڪندو",
  contact_customer: "کسٹمر سے رابطہ کریں",
  sell_online: "آن لائن فروخت کریں",
  latest_transaction: "هاڻوڪو",
  reminder1: "ياد ڏياريندڙ",
  collect_today: "ا گڏ ڪيو",
  pending_collection: "رڪيل مجموعو",
  collect_on: "گڏ ڪرڻ",
  send_reminder: "نصيحت موڪل",
  set_new_date: "نئين تاريخ کي ترتيب ڏيو",
  active_filter2: "موجوده فلٽر",
  collection_set_successfully: "جمع ڪرائڻ جي تاريخ مقرر ڪئي وئي",
  total_earning: "کل آمدني",
  not_earned_money:
    "توهان ڪو پئسو ڪمو ناهي کمايو ، هاڻي ڪمائڻ لاءِ دوستن سان حصيداري ڪريو.",
  app_installed: "ايپ انسٽال ٿيل",
  two_entries_done: "2 داخلائون مڪمل ڪيون ويون",
  rs10_earned: "10 روپيا ڪمايا",
  add_phone_number: "موبائل نمبر شامل ڪريو",
  add_phone_to_set_date: "جمع ڪرڻ جي تاريخ مقرر ڪرڻ لاءِ موبائل نمبر داخل ڪريو",
  remind_with_whatsapp: "واٹس ایپ ذريعي ياد ڏياريو",
  remind_with_sms: "ايس ايم ايس ذريعي ياد ڏيارجو",
  no_pending_collections: "مبارڪون. وڌيڪ ادائيگي ناھي",
  no_collection_for_today: "اڇ جمع ڪرائڻ لاءِ ڪوبه چارج ناهي",
  remove_colletion_from_selected:
    "چونڊ رابطن مان جمع ڪرائڻ جون تاريخون ختم ڪريو؟",
  collection_removed_successfully: "جمع ڪرائڻ جي تاريخ ڪاميابي سان ختم ٿي وئي",
  no_collection_today_line_1: "آج کوئی پیسہ نہیں ملا۔",
  no_collection_today_line_2: "میں جائیں اور جمع کرنے کی تاریخ طے کریں۔",
  no_collection_upcoming_line_1: "آنے والی کوئی رقم نہیں ہے۔ کے پاس جاؤ",
  turn_off_invoice_for_all:
    "کیا آپ مستقبل کے سارے لین دین کی اپنے آپ جانے والی رسیدیں بند کرنا چاہتے ہیں؟",
  billbook: "بل ڪتاب",
  search_item: "Search item",
  items_list: "ادل جي فهرست",
  item_name: "شيء جو نالو",
  item_stock: "اسٽاڪ شيون",
  enter_item_stock: "اسٽاڪ شيون",
  selling_price: "وڪرو جي قيمت",
  enter_selling_price: "جڏهن ته وڪري جي قيمت",
  cost_price: "خرید قيمت",
  enter_cost_price: "خرچ جي قيمت",
  add_price: "قدر شامل ڪريو",
  edit_item: "شيء ۾ تبديلي آڻيو",
  low_stock: "گھٽ اسٽاڪ",
  bill_details: "بل تفصيل",
  item: "اسم",
  items: "اسم",
  cash_added_to_contact: "ڪيش تي ڪيش ۾ شامل ڪيو ويو آهي",
  net_profit: "نج منافو",
  all_time: "هر وقت",
  this_week: "هن هفتي",
  this_month: "هن مهيني",
  // bill: 'بل',
  bill_can_be_edited_cashbook: "بل چئجي حذف ٿي سگهي ٿو / تي بل ۾ ترميم",
  add_items: "شيون شامل ڪريو",
  select_items: "شيون چونڊيو",
  no_items_added_recently: "في حال شيون",
  current_bill: "موجوده بل",
  press_the_mark_to_add: "اتي اڳ ۾ ئي ٿيل آهي",
  item_already_in_bill: "شيء اڳ ۾ ئي بل کي شامل ڪيو ويو آهي",
  item_with_this_name_exists:
    "هن شيء جو نالو اڳ ۾ ئي موجود آهي، هڪ نئون نالو داخل ڪريو",
  sales_amount: "سهڻا رقم",
  sales_amount_placeholder: "سيلز ٽيڪس جي رقم",
  cost_amount: "قيمت مني",
  cost_amount_label: "رقم جي لاڳت (جي ضرورت ناهي)",
  cost_amount_placeholder: "خرچ جي رقم",
  optional_information: "اضافي معلومات",
  your_loss: "توهان جو نقصان",
  your_profit: "توهان جي نفعي",
  items_added: "شيون شامل",
  remove: " مٽائڻ",
  enter_note_terms: "هن نوٽس / اصطلاحن",
  select_payment_information_optional: "ادائگي جي معلومات (جي ضرورت ناهي)",
  has_the_bill_paid: "بل کي ڇا ٿيو؟",
  select_bank: "ڪناري کي منتخب ڪريو",
  select_wallet: "مهرباني ڪري هن پرس کي چونڊيو",
  total_Entries: "7 ڊيٽا داخل جو هڪ مجموعو",
  start_date: "شروعاتي تاريخ",
  end_date: "مقرر تاريخ",
  save_items: "شيون کانسواء",
  add_an_item: "جي غيرموجودگي سبب شامل ڪريو",
  bill_items: "مال جو بل",
  share_bill: "بل موڪليو",
  do_not_share_bill: "بل موڪلي نه ٿا",
  add_details: "تفصیلات شامل کریں",
  optional: "(ضروری نہیں)",
  waiting_for_code_2: "کوڈ کا انتظارکررہے ہیں",
  net_udhaar: "خالص اڌار",
  net_advance: "خالص ايڊوانس",
  advance_payment: "ايڊوانس رقم",
  advance_amount: " ايڊوانس پئسو",
  contacts: "رابطا",
  select_mobile_network_placeholder2: "ليجر محفوظ ۽ تصديق ڪئي وئي ،",
  take_photo: "فوٽو وٺو",
  with_camera: "ڪئميرا سان",
  ledger_secured: "ليجر محفوظ ۽ تصديق ڪئي وئي ،",
  friends_at_udhaar: "- توهان جا دوست ڪريڊٽ تي",
  new_transaction: "نیا ثرانزيڪشن",
  buy: "خريد",
  sell: "وڪرو",
  going_back_will_discard_transaction:
    "واپس جانے سے آپ کا لکھا ہوا ختم ہو جاۓ گا",
  go_back: "واپس جاو",
  cashbook_report: "کیش بک رپورٹ",
  profit: "منافع",
  total_sales: "کل فروخت",
  total_expense: "کل اخراجات",
  select_report_type: "رپورٹ کی قسم منتخب کریں",
  download_pdf: "پی ڈی ایف ڈاؤن لوڈ کریں",
  detailed_report: "تمام اندراجات کے ساتھ تفصیلی رپورٹ",
  summary_report: "دن کی سمری رپورٹ",
  other_category_label: "دوسری قسم",
  recharge: "ریچارج",
  connect_your_account: "اپنا اکاؤنٹ جوڑیں",
  earn_upto_3_commission: "Earn up to",
  // commission: 'کمیشن',
  on_easy_load: "ایزی لوڈ پر",
  add_balance_for_easyload: "ایزی لوڈ کے لیے بیلنس ڈالیں",
  now_you_can_collect_payment_digitally_with_udhaar_app:
    "اب آپ ادھار ایپ کے ذریعہ ڈیجیٹل طور پر ادائیگی جمع کرسکتے ہیں",
  congratulations: "مبارک ہو!",
  did_not_receive_deposit_try_again: "جمع نہیں کیا؟ دوبارہ کوشش کریں",
  verify_account: "اکاؤنٹ کی تصدیق کریں",
  video: "ویڈیو",
  camera_permission: "سيٽنگ مان ڪئميرا استعمال جي اجازت ڏيو",
  invite_sent: "انوائٹ موڪلي وئي",
  user_already_user_udhaar: "اهو صارف اڳ ۾ ئي اڌار ايپ استعمال ڪري رهيو آهي",
  rs_20_earned: "۲۰ روپيا کٽي ويو",
  invite: "انویٹ",
  remark: "تفصيل",
  remark_is_required: "تفصيل ضرور لکيا وڃن",
  total_cash_in: "ڪل ڪيش اِن",
  total_cash_out: "ڪل ڪيش آئوٽ",
  save_invoice: "انوائس محفوظ ڪريو",
  add_item_list: "شيون شامل ڪريو",
  enter_invoice_total: "انوائس جو مجموعو لکو",
  has_this_invoice_been_paid: "ڇا هي انوائس ادا ڪئي وئي؟",
  add_customer_2: "گراهڪ ٺاهيو",
  add_items_to_invoice: "انوائس ۾ شيون لکو",
  stock: "اسٽاڪ",
  pcs: "پیسس",
  create_new_stock_item: "نئين اسٽاڪ واري شيءَ ٺاهڻ",
  import_items: "آئٽم درآمد ڪريو",
  selling_price_optional: "وڪري جي قيمت (گهربل ناهي)",
  cost_price_optional: "خريداري قيمت (گهربل نه آهي)",
  current_stock_optional: "موجوده اسٽاڪ (گهربل نه آهي)",
  qty_for_low_stock_alert: "گهٽ اسٽاڪ الرٽ جي مقدار چو",
  items_total: "فائنل بیلنس",
  confirm_invoice_amount: "انوائس جي رقم جي تصديق ڪريو",
  your_invoice_amount_is: "توھان جي انوائس جي رقم",
  invoice_successfully_saved: "انوائس محفوظ ٿي وي",
  send_invoice: "انوائس موڪليو",
  create_new_invoice: "نئين انوائس ٺاهيو",
  share_invoice: "انوائس شیئر ڪريو",
  do_not_share: "شیئر نه ڪرڻنو",
  invoice_book_report: "انوائس بڪ جي رپورٽ",
  final_balance: "فائنل بیلنس",
  mobile_phone_number: "موبائل فون نمبر",
  item_list_tafseel: "شين جي فهرست / تفصيل (گهربل نه)",
  send_free_sms_to: "ڏانهن مفت ايس ايم ايس موڪليو",
  only_you_and: "صرف توهان",
  can_see_these_entries: "توهان اهي انٹریرو ڏسي سگهو ٿا",
  add_first_transaction_of: "جو پهريون حساب ڪتاب لکو",
  cashbook_description:
    ".اپنے فروخت اور اخراجات کا حساب لکھیں. اور کسٹمرز کو فری بل اور انوائس بھیجیں",
  invoicebook_description:
    ".پنهنجو وڪرو ۽ خريداري انوائس ٺاهيو جوٽ ان پٽ ، آساني سان. شیئر ڪريو گراهڪن سان ڪريڊٽ گڏ ڪرڻ 3 ڀيرا تيز ڪيو",
  udhaarbook: "اڌار بڪ",
  cash_in_caps: "آنے والی رقم",
  cash_out_caps: "کیش آؤٹ رقم",
  stock_book: "اسٹاک بک",
  all_items: "All items",
  out_of_stock: "Out of stock",
  stock_of_goods: "سامان کا اسٹاک",
  manually_added: "دستی طور پر شامل کیا گیا",
  manually_reduced: "دستی طور پر کم کیا گیا",
  manage_stock_items: "اسٹاک آئٹم انتظام کریں",
  add_new_item: "نئی چیز شامل کریں",
  select_unit: "یونٹ منتخب کریں",
  no_item_found: "کوئی شے نہیں ملی",
  delete_item: "آئٹم کو ڈیلیٹ کریں",
  all_data_of_this_item_will_be_deleted: "اس آئٹم کا سارا ڈیٹا ڈیلیٹ ہوجائے گا",
  manage_stock: "اسٹاک انتظام کریں",
  collect_payment: "ادائیگی جمع کریں",
  share_promotions: "پروموشنز شیئر کریں",
  win_daily_cash_prizes: "روزانہ انعامات جیتیں",
  unlock_cash_prize: "انعامات انلاک کریں",
  switch_on_quiz_in_3_steps: "کوئز آن کرنے کے 2 آسان اقدامات",
  start_using_udhaar_book: "ادھار بک کا استعمال کرنا شروع کریں",
  pakistans_biggest_cash_reward_app: "پاکستان کا سب سے بڑا نقد انعام ایپ",
  play_quiz_and_win_cash_prizes_worth_10k:
    "روزانہ 10،000 انعام کوئز کھیلیں اور پیسے جیتیں",
  item_will_be_added_to_stock: "آئٹم اسٹاک میں شامل کیا جائے گا",
  customer_added_successfully: "کسٹمر کامیابی کے ساتھ شامل ہو گیا",
  customer_deleted_successfully: "کسٹمر کامیابی کے ساتھ ڈیلیٹ ہو گیا",
  invitation_successfull: "دعوت کامیابی کے ساتھ بھیج دی گئی",
  landmark: "مشہور جگہ",
  enter_landmark: "مشہور جگہ درج کریں(لازمی نھیں ھے)",
  landmark_required_to_access_recharge:
    "لینڈ مارک لازمی ہے ری چارج تک پھنچنے کے لیے",
  send_money: "حساب کلیئر",
  collect_money: "Collect Money",
  balance_settled: "رقم موڪليو",
  create_new_item: "نیا آئٹم بنائیں",
  view_item: "View Item",
  save_items_to_invoice: "آئٹمز کو انوائس میں محفوظ کریں",
  infoAdded: "معلومات کامیابی کے ساتھ شامل کردی گئیں",
  added: "شامل کیا",
  Request_Send: "Request Send",
  are_you_sure_you_want_to_delete_business:
    "توهان واقعي هن ڪاروبار کي ڊليث ڪرڻ چاهيو ٿا؟",
  u_paisa: "یوپیسا",
  going_back_will_discard_changes:
    "واپس وڃڻ سان توھان جي تبديليون ضايع ٿي وينديون",
  amount_due: "واجب الادا رقم",
  payment_due: "ببقه ادائيگي",
  invoice_to: "ڏانهن انوائس",
  amount_should_be_a_numbers: "رقم نمبروں میں ھونی چاہئے",
  select_invoice_method: "انوائس جو طريقو چونڊيو",
  info_updates: "معلومات کامیابی کے ساتھ اپ ڈیٹ ہو گئیں",
  info_added: "معلومات کامیابی کے ساتھ شامل ہو گئیں",
  info_deleted: "معلومات کامیابی کے ساتھ ڈیلیٹ ہو گئیں",
  unpaid: "ادا نہیں  کیا",
  close: "بند کریں",
  user_exist: "صارف پہلے سے موجود ہے",
  ucash: "یو کیش",
  ucash_balance: "یو کیش بیلینس",
  view_details: "تفصيلات ڏسو",
  sell_easyload: "ايزي لوڊ وڪڻڻو",
  earn_commission_upto_3: "2.2٪ تک کمیشن کمائیں",
  best_in: "میں بہترین",
  ucash_descp:
    "ادائیگی 3x تیزی سے جمع کریں۔ 1٪ تک کیش بیک کے ساتھ اضافی رقم کمائیں",
  get_early_access: "جلد رسائی حاصل کریں",
  we_have_added_you_to_wait_list: "آپ کو انتظار کی فہرست میں شامل کیا گیا",
  there_are: "وہاں ہے",
  people_ahead_of_you_to_earn_upto_1_cashback:
    "لوگ آپ سے آگے ھیں 1 فیسد تک کیش بیک جیتنے کے لیے",
  want_fast_access: "تیز رسائی چاہتے ہیں",
  rp_50_recharge_ready: "توهان جو Rs 50 ريچارج تيار آهي!",
  avail_recharge_share_now:
    "انهي ريچارج جو فائدو کڻڻ جي لاءِ هاڻي هن کي پنهنجن دوستن سان شئیر ڪريو ۽ هيش ٽيگ کي عنوان ۾ رکجي.",
  add_cash: "Add Cash",
  promotion: "پرومشن",
  play_one_rupee: "1 روپے گیم کھیلیں",
  bill_payment: "بل کی ادائیگی",
  get_bill_discount: "Get up to Rs.12.25 on each bill",
  leaderboard: "ليڊر بورڊ",
  leaderboard_descp: "وڊيڪ ريچارج وڪڻڻو ۽ بائیک کٽيو",
  sale_invoice: "سیل انوائس",
  expense_bill: "خرچن جو بل",
  business_Added_success: "کاروبار شامل کر دیا گیا ہے",
  maximun_limit_10000: "زیادہ سے زیادہ ادائیگی کی حد 10،000 ہے", //need to update
  transaction_paid_successfully: "ٹرانزیکشن کامیابی سے ادا کی گئی ہے",
  do_you_want_to_delete_image: "کیا آپ تصویر کو ڈیلیٹ کرنا چاہتے ہیں؟",
  items_added_success: "آئٹمز کو کامیابی کے ساتھ شامل ہو گیا ہے",
  no_item_found_add: "کوئی آئٹم نہیں ملا، ابھی شامل کریں",
  stock_updated_success: "اسٹاک کامیابی کے ساتھ اپ ڈیٹ ہوگیا ہے",
  stock_deleted_success: "اسٹاک کو کامیابی کے ساتھ ڈیلیٹ کر دیا گیا ہے",
  business_deleted_success: "کاروبار کو کامیابی کے ساتھ ڈیلیٹ کر دیا گیا",
  update_amount_with_item_total: "آئٹم ٹوٹل  کے ساتھ رقم اپ ڈیٹ کریں",
  wallet_not_available: "والٽ موجود ناهي",
  wallet_is_currently_not_available:
    "دوبارہ کوشش کرنے کے لیے ایپ کو ریفریش کریں",
  date_time: "تاریخ/وقت",
  description: "تفصیل",
  failed: "ناڪام",
  deposit: "جمع کی رقم",
  ucash_report: "یوکیش رپورٹ",
  total_easyload_given: "کل دیا گیا ایسی لوڈ",
  unable_to_get_wallet_balance: "والٹ بیلینس حاصل ھونے میں نا ممکن",
  ucash_list: "يو ڪيش جي تفصيل",
  couldnt_request_early_access: "جلدی رسائی کی درخواست نہیں کرسکا",
  easypaisa_account_number: "ایزی پیسہ اکاؤنٹ نمبر",
  jazzcash_account_number: "جاز کیش اکاؤنٹ نمبر",
  enter_easypaisa_account_number: "EasyPaisa اکاؤنٹ نمبر درج کریں",
  enter_jazzcash_account_number: "جاز کیش اکاؤنٹ نمبر درج کریں ",
  your_account_number_is_easy_paisa_number:
    "آپ کا اکاؤنٹ نمبر عام طور پر آپ کا EasyPaisa فون نمبر ہوتا ہے",
  your_account_number_is_jazzcash_number:
    "آپ کا اکاؤنٹ نمبر عام طور پر آپ کا JazzCash فون نمبر ہے",
  two_steps_away_from_percent: "2.5٪ کمانے سے 2 قدم دور",
  enter_deposit_amount: "جمع کی ھوی رقم درج کریں",
  deposit_for_easyload: "ایزی لوڈ کیلئے جمع کروائیں",
  enter_the_amount_you_want_to_deposit:
    "اپنے ایزی لوڈ اکاؤنٹ کے لئے جو رقم جمع کروانا چاہتے ہو اسے درج کریں",
  one_steps_away_from_percent: "2.5٪ کمانے سے 1 قدم دور",
  confirm_transfer: "ٹرانسفر کنفرم کریں",
  easypaisa_will_send_you_a_pin: "ايزي پيسا توهان کي هڪ پن موڪليندو",
  jazzcash_will_send_you_a_pin: "جازڪيش توهان کي هڪ پن موڪليندو",
  enter_pin_easypaisa: "مھرباني ڪري ايزي پيسا ايپ ۾ پنھنجو پن داخل ڪريو",
  enter_pin_jazzcash: "مھرباني ڪري جازڪيش ايپ ۾ پنھنجو پن داخل ڪريو",
  amount: "رقم",
  from: "کس سے",
  to: "کس کو",
  your_easyload_account: "آپ کا ایزی لوڈ اکاؤنٹ",
  get_pin: "پن حاصل ڪريو",
  easyload_deposit_MPIN_confirm: "ایزی لوڈ ڈپازٹ کی لئے، ایم پن کی تصدیق کریں",
  request_mpin: "MPIN کی درخواست کریں",
  verify_mpin: "MPIN کی تصدیق کریں",
  did_not_recieve_mpin: "MPIN نھیں پھنچی",
  try_again: "پھر سے کوشش کریں",
  open_easypaisa_and_enter_pin: "ايزي پيسا ايپ کوليو ۽ پن داخل ڪريو",
  open_jazzcash_and_enter_pin: "جازڪيش ايپ کوليو ۽ پن داخل ڪريو",
  waiting_for_you_to_verify_easyload_easypaisa:
    "ايزي پيسا ايپ تي ايزي لوڊ جمع ڪرڻ",
  waiting_for_you_to_verify_easyload_jazzcash:
    "جازڪيش ايپ تي ايزي لوڊ جمع ڪرڻ جي رقم جي تصديق جو انتظار آهي.",
  deposit_failed_mpin_not_verified:
    "جمع کروانے میں ناکام۔ MPIN کی توثیق نہیں ہوئی۔ ",
  to_earn_35_on_easyload_verify_mpin:
    "ایزی لوڈ پر 2.5٪ کمانے کے لئے ، اپنے MPIN کی توثیق کریں۔",
  amount_deposited: "رقم جمع کردی گئی",
  ucash_deposit: "يوڪيش جمع",
  done: "ھو گیا",
  setup_for: "کے لئے سیٹ اپ",
  finish_hbl_payment: "5 آسان مراحل میں HBL ادائیگی کا سیٹ اپ مکمل کریں۔",
  earn_commission_upto_2: "Earn 2.5% commission",
  login_into_hbl: "اپنے HBL ایپ میں لاگ ان کریں",
  tap_on_more_btn: '"مزید" کے بٹن پر ٹیپ کریں',
  select_corporate_payment: "کارپوریٹ ادائیگی کا انتخاب کریں",
  select_udhaar_app_from_dropdown: "ڈراپ ڈاؤن سے اُدھار ایپ کا انتخاب کریں",
  add_details_and_done: "تفصیلات شامل کریں اور آپ کا کام ہوجاۓ گا",
  waiting_for_mpin: "MPIN جو انتظار",
  add_ucash_balance: "یو کیش بیلنس شامل کریں",
  takeout_cash: "ٽيڪ آوٽ ڪيش",
  add_your_bank_account: "اپنا بینک اکاؤنٹ شامل کریں",
  to_change_bank_click_edit:
    "پنهنجو اڪائونٽ شامل يا تبديل ڪرڻ لاءِ آئکن تي ڪلڪ ڪريو",
  account_number: "اکاونٹ نمبر",
  enter_account_number: "اکاؤنٹ نمبر درج کریں(#Ph)",
  number: "نمبر",
  insufficient_balance: "ناکافی بیلینس",
  unable_to_withdraw: "واپس وٺڻ کان قاصر",
  cash_take_out_successful: "ڪيش ٽيڪ آوٽ ڪامياب ٿي ويو",
  cash_taken_out: "ڪيش ٽيڪ آوٽ",
  cash_will_be_deposited_in_24_hours:
    "24 ڪلاڪن اندر توهان جي اڪائونٽ ۾ رقم ملندي.",
  easyload_details: "ايزي لوڊ جي تفصيلات",
  search_customer_by_phone: "کسڈمرس کو موبائل نمبر سے ڈھونڈیں #",
  contact_not_found: "کانکیکٹ نہیں ملا",
  setup_easyload_and_earn_up_to_35: "سیٹ اپ ایزی لوڈ اور %2.5 تک کمیشن کمائیں",
  finish_easyload_setup_2_steps: "3 مراحل میں ایزی لوڈ سیٹ اپ ختم کریں",
  earn_upto_35_commission: "2.5٪ تک کمیشن حاصل کریں",
  step_one: "اسٹیپ  1",
  step_two: "اسٹیپ  2",
  step_three: "اسٹیپ  3",
  tap_here: "یہاں کلک کریں",
  setup_screenlock: "اسکرین لاک سیٹ اپ کریں",
  enter_location: "مقام درج کریں",
  location_is_mandatory: "مقام لازمی ہے",
  location_permission: "سیٹنگ میں جا کر اپنی لوکیشن آن کریں",
  location_permission: "Allow location permission from setting",
  add_balance_with_easypaisa_hbl_ubl:
    "بیلینس ڈالیں EasyPaisa یا HBL یا JazzCash کے ذریعے",
  easyload_and_earn_upto_35: "ایسی لوڈ کریں اور ٪5۔3 تک جیتیں",
  cash_back: "يو ڪيش",
  recharge_report: "ریچارج رپورٹ",
  udhaar_bonus: "ادھار اضافی انعامات",
  load: "Recharge",
  package: "پيڪيجز",
  packages: "پيڪيجز",
  select_a_package: "پيڪيج چونڊيو",
  view_package_details: "پيڪيج جي تفصيل ڏسو",
  unable_to_get_networks: "نیٹ ورکس نہیں مل سکے",
  enter_phone_number: "موبائل نمبردرج کریں",
  easyload_amount: "ایسی لوڈ کی رقم",
  enter_easyload_amount: "ایسی لوڈ کی رقم درج کریں",
  minimum_recharge_amount_limit_50: "کم سے کم ریچارج کی رقم 50 ھونی چاھئیں",
  package_summary: "Package summary",
  commission_details: "کمیشن کی تفصیلات",
  udhaar_book_cashback: "ادھار بک کیش بیک",
  confirm_package: "Confirm Package",
  confirm_easyload: "Confirm easyload",
  sms_reciept_has_been_sent_to: "ایس ایم ایس کی رسید بھیجی گئی ہے",
  easyload_dispute_descp:
    "کیا غلط نمبر پر ٹرانزیکشن ہو گئی ہے؟ صحیح کروانا چاہتے ہیں؟",
  select_entry_to_file_dispute:
    "اُس ایزی لوڈ کو منتخب کریں جس پرایزی لوڈ نہیں ہوا",
  active_disputes: "جو ایزی لوڈ نہیں ہوا",
  pending_disputes: "جو ایزی لوڈ ہوگیا",
  would_you_like_to_file_a_dispute:
    "کیا غلط نمبر پر ٹرانزیکشن ہو گئی ہے؟ صحیح کروانا چاہتے ہیں؟",
  easyload_dispute_report: "جو ایزی لوڈ نہیں ہوا اس کی رپورٹ",
  refresh: "ریفریش",
  choose_category: "تفصیلی فہر ست سے منتخب کریں",
  catalog_builder: "آئٹم کی تفصیلی فہر ست",
  catalog_descp:
    "ہماری پہلے سے موجودہ آئٹم کی تفصیلی فہر ست سے اپنا آئٹم منتخب کریں اور اپنی فہر ست بنائیں",
  select_products: "آئٹم منتخب کریں",
  cnic_placeholder: "13 عدد CNIC نمبر داخل ڪريو",
  cnic_number_length: "شناختی کارڈ نمبر 11 ہندسوں کا ہونا چاہیے",
  sync: "سینک",
  Request_Send_success:
    "توھان جي ادائيگي جي درخواست ايس ايم ايس جي ذريعي موڪلي وئي آھي",
  only_edit_from: "توھان ھن ٽرانزيڪشن کي { } مان ايڊٽ ڪري سگھوٿا",
  invoice_book: "انوائس بک",
  purchase_invoice: "Purchase Invoice",
  purchase_bill: "Purchase bill",
  purchase_report: "Purchase report",
  account_locked_description:
    " آپ کا اکاؤنٹ بند ہوگیا ہے, مزید معلومات کے لیے ہم سے رابطہ کریں",
  not_editable: "توھان ھن ٽرانزيڪشن ڪي ايڊٽ نٿا ڪري سگھو",
  dispute_active: "موجودہ",
  dispute_completed: "مکمل",
  data_sync_karein: "ڈیٹا سینک کریں",
  syncing: "سینکنگ",
  items_updated_success: "آئٹمز کامیابی کے ساتھ اپ ڈیٹ ہوگیا ہے",

  // Salary Book
  paybook: "تنخوابک",
  add_staff_and_maintain_your_daily_attendance:
    "اسٹاف شامل کریں اورروزانہ کی حاضری کو برقرار رکھیں",
  add_staff: "اسٹاف شامل کریں",
  total_present: "کُل حاضر",
  total_absent: "کُل غیر حاضری",
  staff_search_placeholder: "اسٹاف(نام یا فون کے ذریعہ تلاش کریں)",
  add_staff_lowercase: "اسٹاف شامل کریں",
  this_number_associate_with_another_staff: "ھي نمبربه عملي سان لااپيل آھي.",
  staff_name: "اسٹاف کا نام",
  enter_staff_name: "عمله کي پگهار ڏيو",
  select_salary_type: "تنخواہ کی قسم منتخب کریں",
  monthly: "ماہانہ",
  monthly_description:
    "مقررہ تنخواہ, ہر ماہ تنخواہ کی ادائیگی ، ماہانہ ادائیگی",
  weekly: "ہفتہ وار",
  weekly_description: "ہفتہ وار ادائیگی ، 7 دن کام کا چکر",
  daily: "روزانہ",
  daily_description:
    "روزانہ کی ادائیگی ، کام کرنے والے دن کی بنیاد پر ادائیگی ",
  hourly: "فی گھنٹہ",
  hourly_description: "پنچ ان - پنچ آؤٹ اوقات ، گھنٹہ ادائیگی کا نظام",
  salary_type_is_required: "تنخواہ کی قسم ضروری ہے",
  enter_salary_amount: "پگهار جي رقم لکو",
  enter_staff_salary: "اسٹاف کی تنخواہ داخل کریں ",
  staff_salary: "عمله / پگهار",
  salary_is_required: "اسٹاف شامل کریں",
  regular_working_hours: "نوکری کے عام اوقات",
  select_your_hours: "گھنٹے منتخب کریں",
  working_hours_req: "Working hours is required",
  select_working_days: "کاروباری دن منتخب کریں",
  working_days_staff_can_be_marked:
    ".ڪاروباري ڏينھن: اسٽاف کي 'حاضر' يا 'غير حاضر' جي طور تي نشان لڳئي سگھو ٿا",
  non_working_days_staff_can_be_marked:
    ".غير ڪاروباري ڏينهن: اسٽاف کي 'موجوده' يا 'چھٹي' جي طور تي نشان لڳئي سگھو ٿا",
  select_working_days_and_hours: "ڪم ڪندڙ ڏينهن ۽ ڪلاڪ چونڊيو",
  select_working_days_small: "ڪم جا ڏينهن چونڊيو",
  save_staff: " اسٹاف محفوظ کریں",
  joining_date: "شامل ہوئے کی تاریخ ",
  select_joining_date: "شامل ہوئے کی تاریخ داخل کریں",
  staff_joining_date: "عملي جي شامل ٿيڻ جي تاريخ",
  staff_success_add: "Staff added successfully",
  all_staff: "کُل اسٹاف",
  present: "حاضر",
  set_date_filter: "تاريخ فلٽر سيٽ ڪريو",
  showing_staff_list_for: "عملي جي فهرست ڏيکاريندي",
  attendance: "حاضري",
  attendance_report: "حاضری کی رپورٹس",
  staff_lowercase: "اسٹاف",
  presents: "حاضر",
  absents: "غیر حاضری",
  days_lowercase: "دن",
  paid_holiday: "ادا ڪيل چھٹي",
  not_marked: "نشان نه لڳل",
  advance_from_staff: "عمله کان ايڊوانس",
  pending_to_staff: "عمله کان ",
  closing_balance_small: "اختتامی بیلنس",
  balance_forward_from_last_month: "گذريل مهيني کان اڳيان جو بيلنس ",
  rs: "روپیہ.",
  payments_small: " ادائيگي",
  net_payments_given_and_taken_from_staff:
    "مڪمل ادائيگي ڏني وئي ۽ عمله کان وصول ڪئي وئي",
  salary: "تنخواہ",
  total_salary_if_no_presents:
    "مڪمل تنخواه - جيڪڏھن ڪا حاضري نه لائي وئي ، تنخواه صفر ٿي ويندي",
  pay_staff: "عمله کي پگهار ڏيو",
  salary_slip: "تنخواہ کی پرچی ",
  salary_must_be_in_numbers: "تنخواہ نمبرمیں ہونی چاہئے",
  salary_cannot_be_0: "تنخواہ 0 نہیں ہوسکتی",
  all_days: "سڄو ڏينهن",
  mark_attendance_in_bulk: "سڄو ڏينهن",
  add_salary: "پيمنٽ  شامل ڪريو",
  enter_salary_and_advance_payments_to_staff:
    "اسٽاف جي پگهار ۽ ايڊوانس پيمنٽ داخل ڪريو",
  total_salary: "کُل تنخواہ ",
  select_dates_for_salary_slip: "پگهار جي پرچي لاءِ تاريخون چونڊيو ،",
  staff_name_is_required: "اسٹاف کا نام داخل کرنا لازمی ھے",
  working_hours_are_required: "کام کے اوقات ضروری ہیں",
  working_hours_must_be_a_valid_number: "کام کے اوقات درست نمبر میں ہونا چاہئے",
  working_hours_cannot_be_a_0: "کام کے اوقات 0 نہیں ہوسکتے ہیں",
  profile_details: "پروفائل کی تفصیلات",
  staff_information: "اسٹاف کی معلومات",
  staff_name_lowercase: "اسٹاف کا نام",
  name: "نام",
  job_title: "نوکری کا عنوان",
  salary_details: "تنخواہ کی تفصیلات",
  salary_type_lowercase: "تنخواہ کی قسم",
  working_hours: "کام کے اوقات",
  working_days: "کاروباری دن",
  other: "Other",
  auto_present: "خودبخد حاضری ",
  delete_staff: " اسٹاف ڈیلیٹ",
  are_you_sure_you_want_to_delete_staff:
    "کیا آپ واقعی میں ڈیلیٹ کرنا چاہتے ہیں؟",
  staff_deleetd_success: "Staff deleted successfully",
  staff_updated_successfully: "اسٹاف اپ ڈیٹ کامیاب ھوا ",
  no_data_for_date_range_was_found: "تاريخ جي حد تائين ، ڪوبه ڊيٽا نه مليو.!",
  are_you_sure_you_want_to_delete_this_payment:
    "کیا آپ واقعی یہ ادائیگی ڈیلیٹ کرنا چاہتے ہیں؟",
  payment_deleted_successfully: "ادائیگی کامیابی سے ڈیلیٹ ہو گئی",
  you_cant_schedule_a_payment_in_past:
    "آپ ماضی کی ادائیگی کا شیڈول نہیں بنا سکتے ہیں ",
  you_paid: "آپ نے ادا کیے",
  you_took: "آپ نے لیے",
  payment_date: "ادائیگی کی تاریخ",
  pay_online: "آن لائن ادائیگی کریں",
  confirm: "تصدیق کریں",
  youre_about_to_transfer_salary_of: "آپ تنخواہ منتقل کرنے والے ہیں ",
  add_staff_account: "اسٹاف کا اکاؤنٹ شامل کریں",
  payment_success: "Payment saved successfully",
  edit_payment: "Edit Payment",
  daily_statement: "Daily statement",
  grand_total: "ڪل تعداد",
  total_number_of_customers: "No. of Customer:",
  payment_details: "ادائيگي جي تفصيلات",
  date_setted_success: "Date setted successfully",
  inventory_value: "انوینٹری کی قیمت",
  inventory_cost: "Inventory Cost",
  stock_items: "اسٽاڪ شيءِ",
  inventory_item: "Inventory Items",
  sale_report: "Sale Report",
  item_sold: "Item Sold",
  total_profit: " کل منافع",

  //changes
  give_salary: "GIVE SALARY",
  give_advance: "GIVE ADVANCE",
  pay_cash: "Pay cash",
  pay_salary: "Pay salary",
  pay_advance: "Pay Advance",
  inventory_report: "Inventory Report",
  verify_cashout: "Verify Cashout",
  send_and_receive_payment: "Send and receive payments online",
  connect_wallet: "Connect Wallet",
  setup_screen_lock: "Setup screen lock",
  lock_is_mandatory: "Lock is mandatory",
  easypaisa: "EasyPaisa",
  jazzcash: "JazzCash",
  popular: "popular",
  please_enter_registered_number:
    "Please enter the mobile number registered with this account",
  connect_you_wallet: "Connect your Wallet",
  enter_password: "Enter password",
  create_new_password: "Create new password",
  re_confirm_password: "Re-confirm password",
  reenter_password: "Re-enter password",
  password_setted: "Password Created Successfully",
  one_steps_away_from_completion: "You are 1 step away from completion ",
  wallet_successful: "Wallet Connected Successfuly",
  whats_your_password: "What's your password?",
  enter_password_to_proceed: "Enter password to proceed to OTP screen",
  incorrect_password: "Incorrect password",
  please_enter_password: "please enter password",
  fee: "Fee",
  password: "Password",
  please_enter_your_pass: "Please enter your password",
  please_confirm_your_pass: "Please confirm your password",
  password_mismatch: "Passwords do not match. Please re-enter your password",
  verify_cashout_details: "Cashout ke details verify karen",

  staff_book: "Staff Book",
  working_hours_can_not_less_24: "Working hours can not be more than 24",
  date: "Date",
  unit: "Unit",
  cnic_number: "CNIC Number",
  suppliers_descp:
    "Supplier add karen aur purchasing maintain karen. Free payment reminder. Wasooli 3x tez",
  add_supplier: "ADD SUPPLIER",
  this_number_associate_with_another_supplier:
    "This number associate with another supplier",
  supplier_added_successfully: "supplier added successfully",
  supplier_deleted_successfully: "supplier deleted successfully",
  create_suppliertitle: "Create Supplier",
  total_supplier: "سپلائرز",
  supplier_name: "Supplier name",
  total_number_of_supplier: "No. of Supplier:",
  supplierprofileheading: "Supplier Profile",
  do_you_want_to_delete_supplier: "Do you want to delete supplier?",
  supplier_statement: "Supplier Statement",
  no_supplier_found: "No supplier found, Add ",
  no_filter_match_supplier: "No supplier matched your filter criteria",

  customer_to_supplier: "Customer converted to Supplier Successfully",
  supplier_to_customer: "Supplier converted to Customer Successfully",
  convert_to_customer: "Convert To Customer",
  convert_to_supplier: "Convert To Supplier",
  convert_all_supplier_entries_to_customer:
    "All entries of this Supplier will be transferred to the Customer section",
  convert_all_customer_entries_to_supplier:
    "All entries of this Customer will be transferred to the Supplier section",
  stock_description:
    "Items add karen aur stock maintain karen. Ready made item catalog. Profit report.",
  supplier_updated_successfully: "Supplier updated successfully",
  quantity: "Quantity",
  customer_depposit_success:
    "Aapke customer k account mein paise deposit hogaye hain",
  cnic_required: "CNIC is required",
  easypaisa_transaction_details: "Easypaisa transaction Details",
  enter_transfer_amount: "Transfer ka amount darj karen",
  easypaisa_in_out: "Easypaisa Money In/Out",
  business_type: "Business Type",

  selling_price_label: "Enter Selling Price (optional)",
  cost_price_label: " Enter Cost Price (optional)",
  category: "Category",
  pay_bill: "pay bill",
  pay_remaining: "باقي ادائيگي ڪريو",
  open_free_account: "مفت اڪائونٽ ٺاهيو",
  remaining_payment: "باقي رقم",
  you_have_received_cashback: "توهان کي Rs. {amount} ڪيش بيڪ مليو آهي!",
  create_account_claim_rewards_note: "انعام حاصل ڪرڻ ۽ بل جي ادائگين تي ڪمائڻ لاءِ روپن اڪائونٽ ٺاهيو.",
  activate_your_wallet: "پنهنجو والٽ فعال ڪريو",
  activate_wallet_note: "ادائيگيون موڪلڻ، وصول ڪرڻ ۽ منظم ڪرڻ تائين فوري رسائي حاصل ڪريو",
  activate_wallet: "والٽ فعال ڪريو",
  no_customer_founds: "No customer found",
  lets_setup_your_udhaar_account: "Let’s set up your Udhaar account",
  pakistans_1_trusted_business_app: "Pakistan's #1 Business Platform",
  you_will_receive_OTP_code: "I will receive an OTP code",
  notes_optional: "نوٽس / تفسيل (اختياري)",
  barcode_label: "Barcode (optional)",
  enter_category: "Enter category",
  Apna_insurance_plan_select_karein: "Apna insurance plan select karen",
  Insurance_summary: "Insurance summary",
  View_insurance_plans: "View insurance plans",
  Request_submitted: "Request submitted",
  Humne_aapki_insurance_request_record_karli_hai_Humara_numainda_jald_aapse_rabta_karayga:
    "Humne aapki insurance request record karli hai. Humara numainda jald aapse rabta karayga.",
  Aap_ka_plan_already_subscribed_hai: "Aap ka plan already subscribed hai",
  Already_subscribed: "Already subscribed",
  order_management: "Order management",
  order_management_capital: "Order Management",
  stock_management: "Stock Management",
  stock_management_small: "Stock management",

  orders: "Orders",
  returns: "Returns",
  order_accepted: "Order accepted",
  order_pending: "Order pending",
  order_returned: "Order returned",
  order_id: "Order id #",
  order_status: "Order status",
  total_price: "Total price",
  reject: "Reject",
  accept_small: "Accept",
  product_id: "Product ID",
  order_qty: "Ordered qty",
  calculation: "Calculation",
  sub_total: "Sub total",
  total_tax: "Total tax",
  discount: "Discount",
  customer_details: "Customer details",
  email_address: "Email address",
  delivery_address: "Delivery address",
  are_you_sure: "Are you sure,",
  you_want_to_reject_this_order: "you want to reject this order?",
  order_reject: "Order Reject",
  please_share_ur_reason: "Please share your reason",
  add_note_to_the_order: "Add a note to the order",
  order_confirmation: "Order confirmation",
  you_want_to_confirm_order: "you want to confirm this order?",
  order_delivered: "Order delivered",
  select_reason: "Select reason",
  available_quantity: "Available qty",
  edit_item_quantity: "Edit item quantity",
  per_item: "Per item",
  ready_to_ship: "Ready to ship",
  enter_reason_here: "Enter reason here",
  order_payment_method: "Payment method",
  You_havent_placed_any_order_yet:
    "You don’t have any orders yet. Once you receive an order, it will appear here.",
  select_dispatch_date: "Select dispatch date",
  dispatch_date: "Dispatch date",
  date_of_purchase: "Date of purchase",
  tracking_id: "Tracking id",
  return: "Return",
  total_return_value: "Total return value",
  evidance_of_return: "Evidance of return",
  evidence: "Evidence",
  total_order_value: "Total order value",
  pending_on_customer: "Pending on customer",
  ready_to_ship: "Ready to ship",
  returned: "Returned",
  delivered: "Delivered",
  delivered: "Delivered",
  rejected: "Rejected",
  shipped: "Shipped",
  cancelled: "Cancelled",
  cod: "COD",
  return_management: "Return Management",
  you_have_not_received_any_return:
    "You haven't received any return orders, when a return occurs, their status will be displayed here.",
  received_customer_return: "Received customer return",
  awaiting_customer_return: "Awaiting customer return",
  add_new_stock: "Add new stock",
  upload_bulk_items: "Upload bulk items",
  upload_or_create_stock: "Upload bulk or create new stock",
  save_for_later: "Save for later",
  save_and_publich: "Save & publish",
  create_stock: "Create stock",
  sub_category: "Sub category",
  brand: "Brand",
  wholesale_price: "Wholesale price",
  msrp: "MSRP",
  minimum_order_qty_optional: "Minimum order qty",
  warranty_period_optional: "Warranty period (optional)",
  specification: "Specification",
  enter_specification: "Enter specification",
  delivery_date: "Delivery date",
  accepted: "Accepted",
  sku: "SKU",
  in_stock: "In stock",
  price: "Price",
  publish: "Publish",
  add_item_details: "Add item details",
  pricing: "Pricing",
  inventory: "Inventory",
  addtional_information: "Additional information",
  discount_optional: "Discount",
  page_not_found: "Page not found",
  we_re_sorry_the_page_you_requested:
    "We're sorry, the page you requested could not be found.",
  stock_image: "Stock image",
  upload_image: "Upload image",
  date_of_creation: "Date of creation",
  customer_tracking_id: "Customer tracking id",
  order_details: "Order details",
  seller_tracking_id: "Seller tracking id",
  creation_date: "Creation date",
  purchase_date: "Purchase date",
  evidence_image: "Evidence image",
  evidence_video: "Evidence video",
  publish_all: "Publish all",
  edit_stock: "Edit stock",
  qty_available: "Qty available",
  item_specification: "Item specification",
  warranty_period: "Warranty period",
  minimum_order_quantity: "Minimum order quantity",
  unpublished: "unpublished",
  waiting_approval: "Waiting for approval",
  delivery_add: "Address",
  managing_your_inventory_has_never:
    "Managing your inventory has never been easier with Udhaar book",
  start: "Start",
  wasooli_tez_safe: "3x tez wasooli. 100% safe.",
  print_label: "Print label",
  publish_item: "Publish item",
  would_you_like_to_publish_this: "Would you like to publish this item",
  would_you_like_to_publish: "Would you like to publish",
  on_your_catalog: "on your catalog ?",
  would_you_like_to_delete: "Would you like to delete",
  this_item: "this item",
  all_selected_item: "all selected items",
  upload_photo: "Upload photo",
  msrp_optional: "MSRP (optional)",
  terms_and_conditions_optional: "Terms and conditions (optional)",
  search_stock_by_name: "Search stock by name",
  delivery_charges: "Delivery charges",
  partner_markup: "Partner markup",
  return_policy_and_warranty_details: "Return policy and warranty details",
  order_filter: "Order filter",
  pdf_option: "Pdf option",
  search_by_order_number_customer_product:
    "Search by order #, customer or product",
  mark_as: "Mark as",
  you_want_to_ship_this_order: "you want to ship this order?",
  print_bill: "Print bill",
  print_loadsheet: "Print loadsheet",
  courier: "Courier",
  accounts: "Accounts",
  in_out: "In / Out",
  saddar_orders: "Saddar Orders",
  saddar_inventory: "Saddar Inventory",
  saddar: "Saddar",
  saddar_managenet: "Saddar Management",
  saddar_seller_central: "Saddar seller central",
  veiw_orders: "View Orders",
  download_template: "Download the template",
  in_the_file: "in the file ?",
  file_zip: "File.zip",
  uploading_with_dot: "Uploading",
  download_invoice: "Download Invoice",
  weight_gm: "Weight (gm)",
  select_weight_type: "Select weight type",
  please_select_order_weight: "Please select order weight",
  select_parcel_type: "Select parcel type",
  please_select_parcel_type: "Please select parcel type",
  ship_order: "Ship order",
  un_publish: "Un publish",
  add_variants: "Add variants",
  stock_variants: "Variants",
  placeholder_item_name: "e.g. Powerbank",
  placeholder_item_category: "Choose category",
  placeholder_item_subcat: "Choose sub category",
  placeholder_item_brand: "Choose brand",
  placeholder_item_price: "e.g. Rs. 1000",
  placeholder_item_discount: "e.g. Rs. 100",
  placeholder_item_quantity: "e.g. 25",
  placeholder_item_moq: "e.g. 5",
  placeholder_item_weight: "e.g. 550 gm",
  placeholder_item_warranty: "Select warranty period",
  placeholder_item_detail: "e.g. 20,000 mAh fast charging",
  placeholder_item_return_policy: "Type warranty and return details here",
  discount_more_than_price: "Discount amount can not be more than Price!",
  view_ledger: "View Ledger",
  ledger: "Ledger",
  search_by_desc_amount_balance: "Search by description, amount or balance",
  ledger_entries: "Ledger entries",
  actions: "Actions",
  time: "Time",
  ledger_management: "Ledger Management",
  ledger_non_ideal_desc:
    "You don't have any entry in the ledger at the moment, when any transaction happens, it will be displayed here.",
  search_by_desc: "Search by description",

  // Sale Book
  open_item: "Open item",
  stock_item: "Stock item",
  sale_pos: "Sale POS",
  draft_sale: "Draft sales",
  sale_items: "Sale items",
  item_non_ideal_desc: "Please add items into the list",
  enter_open_amount: "Enter open item amount",
  current_sale: "Current sale",
  clear_item: "CLEAR ITEMS",
  pos_clear_all_items_title: "Clear all items?",
  pos_clear_all_items_body:
    "Are you sure you want to clear all items from the list?",
  new_sale: "New sale",
  checkout: "Checkout",
  order_summary: "Order summary",
  item_name: "Item name",
  qty: "Qty",
  amount: "Amount",
  tax: "Tax",
  payment_successfully: "Payment successful",
  amount_paid: "Amount paid via",
  change: "Change",
  print_recipt: "PRINT RECEIPT",
  online_payment_checkout: "Record your sale as online payment",
  udhaar_checkout: "Record your sale as Udhaar",
  bill_amount: "Bill amount",
  online_payment: "Online payment",
  start_selling: "Start selling items",
  create_stock_book_item: "Create items in inventory or start selling open items",
  sell_open_item: "SELL OPEN ITEMS",
  start_creating_item: "START CREATING ITEMS",
  max_limit_reached: "Max limit reached",
  draft_message: "Do you want to save this order into draft sales?",
  discard: "DISCARD",
  no_draft_sale: "No draft sales to display",
  no_draft_sale_desc: "You haven’t had any draft sales yet.",
  on_going_sale: "Ongoing sale",
  on_going_sale_desc:
    "Do you want to save this sale before continue the another sale?",
  sale_history: "Sales history",
  no_order_history: "No order history to display",
  no_order_history_desc: "You haven’t had any order history yet.",
  order_history_detail_desc:
    "Click on sale from the list to view sale details.",
  order_no: "Order no",
  sale_details: "Sale details",
  download_recipt: "Download receipt",
  print_receipt: "Print receipt",
  sales_history: "Sales history",
  sale_book: "Sale Book",
  print_invoice: "Print invoice",
  filter_sort: "Filter & Sort",
  view_invoice: "view invoice",
  tax_added: "Tax added",
  add_tax: "Add tax",
  disount_added: "Discount added",
  add_dicount: "Add discount",
  subtotal: "Subtotal",
  enter_cash_amount: "Enter cash amount",
  charge_rs: "Charge RS",
  enter: "Enter",
  shift: "Shift",
  stock_list_desc: "Do you want to update the item price in the stock list as well?",
  note_placeholder: "Add note (e.g. Ali Sahab ka samaan)",
  online: "online",
  paid_via: "Paid via",
  search_order: "Search by customer name, amount, or sale number",
  saleID: "sale ID",
  search_items: "Search items",
  no_result: "No results found",
  create: "Create",
  as_new_item: "as new item",
  date_range: "Date range",
  additional_details: "Additional details",
  order_history_not_found: "Order history not found",
  this_product_has_options_like_size_or_color:
    "This product has options like size or color",
  account_overview: "Accounts overview",
  stock_overview: "Stock overview",
  dat_set_karein: "Date set karen",
  as_customer: "as customer",
  as_supplier: "as supplier",
  supplier: "Supplier",
  enter_phone_number: "فون نمبر داخل ڪريو",
  enter_supplier_name: "Enter supplier name",
  type_name: "Type name",
  udhaar_payment_success: "This transaction also added in Accounts",
  order: "Order",
  max_validation_message: "can't be greater than",
  min_validation_message: "can't be less than",
  file_size_validation: "File size no more than",
  image_format_valid: "Please select a valid image file (JPEG, PNG, or JPG)",
  cant_be: "can't be",
  yearly: "Yearly",
  weekly: "Weekly",
  daily: "Daily",
  monthly: "Monthly",
  overview: "Overview",
  purchases: "purchases",
  non_ideal_graph_udhaar_title: "Udhaar ka hisab nahi dikh raha?",
  non_ideal_graph_udhaar_subtitle:
    "Abhi record karen or muntakhib muddat ke liye udhaar ka hisab kitab dekhen",
  graph_udhaar_btn_title: "Udhaar record karen",
  non_ideal_acc_udhaar_title: "isne apka Udhaar dena hai?",
  non_ideal_acc_udhaar_subtitle:
    "Abhi customer add karen or unke saath udhaar ka hisab record karen",
  pending_accounts: "Pending accounts",
  amount_in_rs: "Amount in Rs.",
  low_stock_item: "Low stock items",
  non_ideal_dash_stock_title: "Har item pe nazar rakhein",
  non_ideal_dash_stock_subtitle:
    "Item kam ho ya ziada, ab nazar rakhein har pal",
  non_ideal_graph_sale_title: "Apni sales ki taraqi dekhen",
  non_ideal_graph_sale_subtitle: "Barwaqt sales ki taraqi dekhte jayein",
  add_sale: "Sales record karen",
  non_ideal_dash_sale_title: "Apne top items se ba-khabar rahen",
  non_ideal_dash_sale_subtitle: "Apka konsa item sab sy ziada demand mein hai?",
  add_top_item: "top item add karen",
  top_sale_item: "Top sale items",
  non_ideal_dash_purchase_title: "Apni tamam kharidari chutki mein dekho",
  non_ideal_dash_purchase_subtitle:
    "Kitne mei lei rahy, kitne mei bech rahy or kitna munafa kama rahy, sab dekho aik jaga pe",
  add_purchase: "kharidari add karen",
  cost_rs: "Cost (Rs.)",
  sale_rs: "Sale Rs.",
  profilt_rs: "Profit Rs.",
  sale_invoice: "Sale invoice",
  create_sale_invoice: "Create sales invoice",
  contact_no: "Contact no",
  due_date: "Due date",
  customer_created: "Customer created successfully",
  supplier_created: "Supplier created successfully",
  enter_total_amount_error: "Please enter Items or Total Amount",
  quantity_error: "Price or Quantity can not be 0",
  not_available: "Not available",
  item_discount_error: "Discount cannot be greater than the item price.",
  enter_tax: "Enter tax",
  cash_small: "cash",
  write_name: "Write name",
  enter_paid_amount: "Enter paid amount",
  enter_recieved_amount: "Enter received amount",
  summary: "Summary",
  balance_amount_error:
    "Received amount cannot be greater than the total amount",
  expense_balance_amount_error:
    "Paid amount cannot be greater than the expense amount",
  sale_balance_amount_error:
    "Paid amount cannot be greater than the sale amount",
  sort: "Sort",
  delivery_challan: "Delivery challan",
  record_payment: "Record payment",
  send_payment: "Send Payment",
  print: "print",
  enter_received_amount: "Enter received amount",
  discard_invoice_desc:
    "Are you sure you want to discard this invoice? This action cannot be undone.",
  discard_invoice_title: "Discard invoice",
  discard_bill_title: "Discard bill",
  discard_invoice_btn: "Yes, discard this invoice",
  discard_bill_btn: "Yes, discard this bill",
  discard_transaction_btn: "Yes, discard this transaction",
  discard_transaction_title: "Discard transaction",
  discard_contact_btn: "Yes, discard this contact",
  discard_contact_title: "Discard contact",
  max_length_6digit: "Max length: 6 digits",
  pos_sales: "POS (sales)",
  inout: "In / Out",
  already_exist_item:
    "This item already exists. Duplicate items are not allowed",
  enter_quantity: "Enter quantity",
  enter_price: "Enter price",
  go_back_invoice_listing: "Go back to invoice listing",
  go_back_invoice_report: "Go back to  report",
  non_ideal_invoice_book:
    "Try search the invoice with another name to find what you’re looking for.",
  sales_report: "Sales Report",
  create_invoice: "Create Invoice",
  preview: "Preview",
  create_purchase_invoice: "Create purchase invoice",
  edit_purchase_invoice: "Edit purchase invoice",
  edit_sale_invoice: "Edit sale invoice",
  edit_invoice: "Edit invoice",
  max_20_character: "Max: 20 characters",
  type_signature_name: "Type signature name",
  invoice_date: "Invoice date",
  po_date: "PO date",
  invoice_items: "Invoice items",
  purchased_items: "Purchased items",
  amount_received: "Amount received",
  partial_paid: "Partial paid",
  units: "Units",
  farokht: "Farokht",
  no_items_have_been_added_to_this_invoice_yet:
    "No items have been added to this invoice yet",
  click_edit_invoice_to_include_the_items_you_billing_for:
    "Click ‘Edit Invoice’ to include the items you’re billing for.",
  no_products_were_added_to_this_invoice:
    "No products were added to this invoice",
  you_can_only_add_items_to_an_invoice_while_its_unpaid:
    "You can only add items to an invoice while it’s unpaid.",
  report_download: "Report Successfully Downloaded",
  backup_in_progress_shortly: "Backup in progress. Please try again shortly",
  error_downloading_report: "Error downloading report",
  successfully_download_invoice: "Successfully Downloaded Invoice",
  create_sale_invoice: "Create sale invoice",
  create_purchase_invoice: "Create purchase invoice",
  want_to_create_purchase_invoice:
    "Want to create a purchase invoice instead? Click here",
  want_to_create_sale_invoice:
    "Want to create a sale invoice instead? Click here",
  create_my_first_invoice: "Create my first invoice",
  start_by_creating_invoice:
    "Start by creating an invoice and keep track of your payments and profits in one place",
  are_you_sure_you_want_to_delete_item:
    "Are you sure you want to delete this item?",
  this_action_cannot_be_undone: "This action cannot be undone",
  contact_number: "Contact number",
  address_business: "Address",
  edit_customer: "Edit customer",
  update_record_sucessfully: "Update record sucessfully",
  amount_rs: "Amount Rs.",
  please_enter_item_name_first: "Please enter item name first!",
  only_one_unit_for_the_selected_item: "Only one unit for the selected item",
  reset_discount_message: "Reset item discount",
  close_without_saving: "Close without saving?",
  invoice_no: "Invoice no",
  item_report: "Item report",
  available_stock: "Available stock",
  low_stock_alert: "Low stock alert",
  profile_tracker: "Profit Tracker",
  total_item_sold: "Total items sold",
  total_item_purchases: "Total purchases price",
  total_sale_price: "Total sale price",
  stock_history: "Stock History",
  custom_date: "Custom date",
  stock_list: "Stock list",
  create_stock_item_details: "Create stock item details",
  edit_stock_item_details: "Edit stock item details",
  stock_book_reports: "Stock Book Reports",
  unsaved_changes: "You have unsaved changes",
  discard_stock: "Yes, discard this stock",
  go_back_item: "Go back to item listing",
  create_as_item: "Create this as new item",
  sell_rs: "Sell (Rs.)",
  costs_rs: "Cost (Rs.)",
  add_more_item_detail: "Add More Item Details",
  add_more_item_detail_desc:
    "Click the + icon to add a new column and include additional details for your item.",
  please_select_primary_unit_first: "Please select the primary unit first",
  secondary_unit_cannot_be_same_to_primary_unit:
    "Secondary unit cannot be the same as the primary unit",
  primary_unit_cannot_be_same_to_secondary_unit:
    "Primary unit cannot be the same as the secondary unit",
  You_can_add_your_custom_unit: "You can add your custom unit",
  item_not_found: "Item not found",
  sorry_could_not_find: "Sorry, we couldn't find",
  you_can_add_stock: "You can add it to your stockbook by clicking below!",
  stock_filter_non_ideal_screen:
    "Try modifying your filters or clearing them to explore all options.",
  sales_report: "Sales report",
  no_report_found: "No report found",
  stock_report_non_ideal_decs:
    "No stock data available. Please add items to your inventory",
  add_items_now: "Add Items Now",
  sale_report_non_ideal_decs:
    "No sales data found. Start making sales to generate reports",
  no_low_stock_found: "No low stock found",
  low_stock_report_non_ideal_decs:
    "No low stock items found. All your products are well-stocked",
  add_unit: "Add unit",
  unit_modal_desc:
    "If this item is available in another unit, you can add it here.",
  unit_conversion_error: "Unit conversion  cannot be zero",
  manufactor_lower_expiry_validation_msg:
    "Manufacturing date must be lower than expiry date",
  expiry_greater_manufactor_validation_msg:
    "Expiry date must be greater or equal than manufacturing date",
  expiry_alert_lower_expiry_validation_msg:
    "Expiry alert must be lower or equal than expiry date",
  are_you_sure_you_want_to_leave_this_screen:
    "Are you sure you want to leave this screen and discard your changes?",
  item_deleted_successfully: "Item deleted successfully",
  stock_report: "Stock report",
  low_stock_report: "Low stock report",
  loss_profit: "Loss/ Profit",
  action: "Action",
  create_your_pin: "Create your PIN",
  setup_pin_security: "Set up a PIN for your security",
  create_pin: "Create PIN",
  setup_pin: "Setup PIN",
  create_your_4digit_udhaar_book_pin: "Create your 4-Digits Udhaar book PIN",
  reconfirm_your_4digit_udhaar_book_pin:
    "Reconfirm Your 4-Digit Udhaar Book PIN",
  pin_code: "PIN code",
  activated: "Activated",
  turn_off: "Turn off",
  change_pin: "Change pin",
  start_by_creating_purchase_invoice:
    "Start by creating an purchase invoice and keep track of your payments and profits in one place",
  sales_report: "Sales Report",
  sales_invoice: "Sales Invoice",
  package_details: "Package details",
  package_done: "Package done",
  package_successfully: "Package is successfully completed",
  delete_single_item: "Are you sure you want to delete this item?",
  delete_multiple_items: "Are you sure you want to delete these items?",
  mobile_recharge: "Mobile Recharge",
  continue: "Continue",
  business_trust: "5.3M+ businesses ka trust",
  Verify_OTP: "Verify OTP",
  otp_code_sent: "We have sent OTP to your",
  enter_4_digit_otp_code: "Enter 4 digit OTP code here",
  wait_time: "Wait time",
  money_khaata_is_updated: "Money’s in — your khaata is updated",
  payment_received_successfully: "Payment received successfully!",
  inventory_updated_with_received_items:
    "Inventory updated with received items",
  whatsapp_number: "Whatsapp number",
  your_data_is_being_restored: "Your data is being restored",
  secured_data_transmission_in_progress:
    "Getting your numbers ready!",
  please_confirm_4_digit_pin: "Please confirm your 4 digits Udhaar book PIN",
  forget_pin: "Forget PIN?",
  back_to_login: "Back to login",
  call_support: "Call  support",
  verify_your_account: "Verify your account",
  verify_your_account_decs:
    "Complete your verification through the Udhaar Book app to reset your PIN. This helps us ensure the security and authenticity of your account.",
  scan_to_open: "Scan to open",
  search_udhaar_book_on_play_store: "Search Udhaar book on Play store",
  or_download: "Or download",
  just_need_few_detail_to_get_started:
    "Just need a few details to get you started",
  kareen_store: "Kareen store",
  otp_verified_successfully: "Your OTP has been successfully verified",
  verify_PIN: "Verify PIN",
  Please_verify_your_4_digits_Udhaar_book_PIN:
    "Please verify your 4 digits RUPIN PIN",
  tries_left: "tries left",
  call: "Call",
  Select_the_options_below_to_receive_a_new_OTP:
    "Select the options below to receive a new OTP",
  phone_sms: "Phone SMS",
  we_will_call_for_OTP_to_your: "We will call for OTP to your",
  hang_tight_ledgers: "Hang tight – your ledgers are almost ready!",
  sale: "Sale",
  keyboard_shortcuts: "Keyboard shortcuts",
  available: "Available",
  delete_bill: "Delete bill",
  delete_invoice: "Delete invoice",
  retry: "Retry",
  suppliers_descp_new:
    "Supplier add karen aur purchasing maintain karen.Free payment reminder. Wasooli 3X tez.",
  add_customer_descp_new:
    "Customer add karen aur khata maintain karen. Free payment reminder. Wasooli 3x tez.",
  i_will_give: "I will give",
  i_will_receive: "I will receive",
  welcome_to_accounts: "Welcome to accounts",
  add_customer_supplier_collection:
    "Add your customers and suppliers to keep collections smooth and credit stress-free.",
  customers: "Customers",
  suppliers: "Suppliers",
  contact_type: "Contact type",
  status: "Status",
  download_files: "Download Files",
  payment_pdf: "Payment PDF",
  payment_detail: "Payment Detail",
  outstanding_orders: "Outstanding Orders",
  return_orders: "Return Orders",
  enter_weight: "Enter weight",
  weight_type: "Weight type",
  select_dimensions: "Select dimensions",
  dimension_type: "Dimension type",
  length: "Length",
  width: "Width",
  height: "Height",
  customers_statement: "Customers Statement",
  suppliers_statement: "Suppliers Statement",
  itook: "I Took",
  igave: "I Gave",
  received: "Received",
  details: "Details",
  invoice_terms_label: "Terms",
  You_are_all_set: "You're All Set!",
  txns_non_ideal_desc:
    "has been added successfully. Start tracking transactions with your customer now.",
  transaction_for: "Transaction for",
  note_placeholder: "Add detailed note here",
  add_image: "Add image",
  upload_new_file: "Upload new file",
  transaction_detail: "Transaction details",
  expense_date_time: "Expense date & time",
  notes: "Notes",
  type: "Type",
  contact_list_non_ideal_title: "Allow Contacts permission from phone",
  contact_list_non_ideal_description:
    "Provide permission from the Udhaar Book app to add all contacts in one go",
  sync_contacts: "Sync contacts",
  hang_on: "Hang on!",
  your_contacts_are_being_synced: "Your contacts are being synced",
  edit_contact: "Edit contact",
  send: "Send",
  message: "Message",
  message_description:
    "Asalam o Alaikum!You have an outstanding amount of Rs. 855 with Book Ocean. Kindly clear your dues at your earliest convenience.Thank you!",
  reminder_type: "Reminder type",
  phone: "Phone",
  due_date_set: "Due date has been set",
  due_date_remove: "Due date has been removed",
  collection_date_set: "Collection date has been set",
  collection_date_remove: "Collection date has been removed",
  we_could_not_find_match: "We couldn’t find any matches for",
  supplier_with_this_number_already_exists:
    "Supplier with this number already exists",
  customer_with_this_number_already_exists:
    "Customer with this number already exists",
  you_can_either_view_supplier_details_or_move_to_customer_tab:
    "You can either view supplier details or move to customer tab",
  you_can_either_view_customer_details_or_move_to_supplier_tab:
    "You can either view customer details or move to supplier tab",
  move_to_customer: "Move to customer",
  move_to_supplier: "Move to supplier",
  view_supplier: "View supplier",
  view_customer: "View customer",
  i_will_give: "I will give",
  i_will_recieve: "I will receive",
  no_more_notebooks_or_spreadsheets: "No More Notebooks or Spreadsheets",
  your_customers_forget_to_pay: "Your Customers Forget to Pay You?",
  never_again: "Never Again!",
  watch_tutorial: "Watch Tutorial",
  five_million_strong: "5.5 Million Strong",
  and_growing_every_day: "- And Growing Every Day",
  no_more_notebooks_spreadsheets: "No More Notebooks or Spreadsheets",
  no_more_notebooks_spreadsheets_description:
    "Keep your receivables and payables organized. Send reminders, record payments, and stay updated on your khata.",
  easy_payment_tracking: "Easy Payment Tracking",
  easy_payment_tracking_description:
    "Quickly add incoming and outgoing payments, with categories to keep your records organized and up-to-date.",
  real_time_account_balances: "Real-Time Account Balances",
  real_time_account_balances_description:
    "Quickly track what customers owe you and what you owe suppliers, all on one simple and easy-to-use screen!",
  a_community_full_of_stories: "A community full of stories",
  testimonial_one:
    "I used to forget who still had to pay me, and it was hard to keep track. Now, I can see all my receivables in one place and even send reminders. It’s made collecting payments so much easier!",
  testimonial_two:
    "I used to forget who still had to pay me, and it was hard to keep track. Now, I can see all my receivables in one place and even send reminders. It’s made collecting payments so much easier!",
  testimonial_three:
    "I don’t have to chase customers anymore. I set reminders, and the app does the rest. I even recovered payments I had forgotten about.",
  testimonial_four:
    "Tracking payments was a headache. Now, I get notified who hasn’t paid, and I just hit ‘Send Reminder’. It’s that simple.",
  create_your_inventory: "Create your inventory",
  low_stocks: "Low Stocks",
  forgot_to_update_them: "and Forgot to Update Them?",
  add_new_products_easily: "Add New Products Easily",
  add_new_products_easily_description:
    "Create items in just a few clicks. Enter product name, unit, price, and stock details quickly—no complexity involved.",
  low_stock_reports: "Low Stock Reports",
  low_stock_reports_description:
    "See what needs restocking at a glance.Generate low-stock reports to plan your purchases and avoid missed sales.",
  quick_stock_adjustment: "Quick Stock Adjustment",
  quick_stock_adjustment_description:
    "Easily update stock quantities anytime.Manually correct stock counts with a few clicks for damaged, lost, or returned items.",
  testimonial_five:
    "I used to struggle with tracking payments and stock manually. Now everything’s in one place—this app is a lifesaver.",
  testimonial_six:
    "Before this, I wrote stock on paper. I always forgot what I sold. Now everything’s logged, and I can see low stock instantly.",
  testimonial_seven:
    "I love the quick item feature. When I’m selling something new, I don’t need to fill everything—just sell and go!",
  testimonial_eight:
    "Adding stock used to take time. Now, I just hit ‘Stock In’ and update everything. No more guesswork.",
  add_sale: "add sale",
  mixing_up_your_sales: "Mixing Up Your Sales?",
  let_simplify_that: "Let’s Simplify That",
  make_sales_second: "Make Sales in Second",
  make_sales_second_description:
    "Handle walk-in sales fast—select items, enter payment type, and instantly print or share the receipt. Perfect for counter and cash sales.",
  send_invoices_get_paid_faster: "Send Invoices That Get Paid Faster",
  send_invoices_get_paid_faster_description:
    "Create professional invoices for your customers. Track due amounts, apply taxes or discounts, and manage credit sales effortlessly with detailed invoices.",
  track_every_rupee_coming: "Track Every Rupee Coming In",
  track_every_rupee_coming_description:
    "Record payments received from customers. Easily track partial or full payments against sales invoices and maintain a clear payment history for every customer.",
  testimonial_nine:
    "Creating and sharing invoices with customers takes just seconds. I no longer have to write anything down manually — the app does it all instantly and neatly.",
  testimonial_ten:
    "Daily sale entries are a breeze with this app. It fits perfectly into my workflow — I can add every sale on the go without missing a beat.",
  testimonial_eleven:
    "This app gives a crystal-clear summary of all my sales. I can review daily, weekly, or monthly progress in seconds, which really helps in making better decisions.",
  testimonial_twelve:
    "It’s easy to track how much cash I received for each sale. The app keeps all incoming payments organized and gives me confidence in my records.",
  no_transactions_to_show_yet: "No transactions to show yet",
  no_transactions_to_show_yet_subtitle:
    "Once you start  record payments, all your activity will appear here",
  go_to_accounts: "go to accounts",
  no_customer_records_yet: "No customer records yet",
  no_customer_records_yet_subtitle:
    "Add your customers in the Accounts section to track what they owe you and manage reminders easily.",
  no_supplier_records_yet: "No supplier records yet",
  no_supplier_records_yet_subtitle:
    "Add your suppliers in the Accounts section to track what you owe and never miss a payment.",
  add_purchase: "add purchase",
  expenses_piling_up: "Expenses Piling Up?",
  organize_and_optimize: "Organize and Optimize.",
  record_all_your_purchases_one_place: "Record All Your Purchases in One Place",
  record_all_your_purchases_one_place_description:
    "Track bills, supplier payments, and expenses easily. No more guesswork—log every outgoing transaction in seconds.",
  smart_stock_easy_purchasing: "Smart Stock, Easy Purchasing",
  smart_stock_easy_purchasing_description:
    "Record purchases from suppliers and update stock automatically. Log item-wise purchases, track dues, and keep your inventory accurate—all in one go.",
  stay_top_of_business_spending: "Stay on Top of Business Spending",
  stay_top_of_business_spending_description:
    "Track non-stock-related business spending. Whether it’s rent, salaries, or utility bills—record every outgoing payment to stay on top of your cash flow.",
  testimonial_thirteen:
    "I use this app to record all my purchases and payments. Everything from stock buying to rent is now documented — and it’s helped me manage my expenses like never before.",
  testimonial_fourteen:
    "One of my favorite features is how it creates reports of all purchases. I can go back and view complete spending history anytime I need, which makes things very transparent.",
  testimonial_fifteen:
    "The ability to generate and send purchase orders directly from the app has made my business much more professional. I no longer have to write them by hand or send scattered messages.",
  testimonial_sixteen:
    "The app gives me full flexibility to mark how I paid — in full, partially, or on credit. This keeps my records accurate and gives me a true picture of my cash flow.",
  view_reports: "View reports",
  over_due_accounts: "Overdue accounts",
  customer_supplier: "Customer / Supplier",
  cta: "CTA",
  item_list: "item list",
  value_Rs_dot: "Value-Rs.",
  stock_value_report: "Stock value report",
  top_selling_items: "Top selling items",
  dashboard: "Dashboard",
  customers: "Customers",
  suppliers: "Suppliers",
  purchase: "Purchase",
  request_reports: "Request reports",
  report_name: "Report name",
  enter_report_name: "Enter report name",
  report_details: "Report details",
  enter_report_details: "Enter report details",
  quantity_sold: "Quantity sold",
  length_width_height: "Length x width x height inches",
  items_type: "Items type",
  unit_type: "Unit type",
  barcode: "Barcode",
  jpg_png_file_size_no_more_than: "JPG or PNG, file size no more than 3MB",
  value: "Value",
  date_filter: "Date Filter",
  current_quantity: "Current quantity",
  stock_in_quantity: "Stock in quantity",
  stock_out_quantity: "Stock out quantity",
  please_select_start_end_date: "Please select start and end date",
  barcode_error: "Barcode error",
  updated_stock_inventory: "Updated stock inventory",
  record: "Record",
  pos: "POS",
  create_pos: "Create pos",
  pos_report: "POS report",
  number_of_transctions: "Number of transctions",
  expence: "Expence",
  purchase_bill_report: "purchase bill report",
  expence_report: "expense report",
  search_customers_by_name_or_posId_placeholder: "Search by name or POS#",
  invoice_report: "Invoice report",
  too_many_walk_ins: "Too Many Walk-Ins?",
  keep_them_smooth_with_pos: "Keep Them Smooth with POS",
  create_pos_sale: "Create POS sale",
  stock_item_in_pos: "Stock Item in POS",
  stock_item_in_pos_description:
    "Add items directly from your stock while making a sale. This way, your inventory updates automatically with every bill — so you always know what’s selling and what’s running low.",
  open_item_description:
    "Open Items are sales created but not yet fully paid. Easily track pending payments, send reminders, and update when customers pay, ensuring you always know which sales are open and the amount still due.",
  draft_sales: "Draft Sales",
  draft_sales_description:
    "Draft Sales let you save orders that aren't ready to be finalized, whether the customer is still deciding or you want to complete the sale later. Easily return to edit or confirm when the customer is ready.",
  forgot_invoices: "Forgot Invoices?",
  we_help_you_stay_on_track: "We’ll Help You Stay on Track.",
  sale_invoice_desc:
    "A Sales Invoice includes all details like items, quantities, prices, taxes, and total amount — so both you and your customer have a clear record of the transaction",
  share_instantly: "Share Instantly",
  share_instantly_desc:
    "Send invoices directly to your customers via WhatsApp, email, or print. No manual writing, no delays — your customer gets the bill right away",
  track_payments: "Track Payments",
  track_payments_desc:
    "Easily see which invoices are fully paid, partially paid, or still pending. This helps you stay on top of collections and follow up on due amounts without missing anything.",
  frustrated_with_unpacked_purchases: "Frustrated with Unpacked Purchases?",
  let_bring_order: "Let’s Bring Order",
  keep_records_organized: "Keep Records Organized",
  keep_records_organized_desc:
    "All purchase orders are stored in one place, so you can quickly check past orders, compare supplier prices, and maintain complete purchase history",
  send_suppliers_easily: "Send to Suppliers Easily",
  send_suppliers_easily_desc:
    "Create and share purchase orders with your suppliers in just a few clicks — through WhatsApp, email, or print. This keeps everything clear and professional.",
  track_pending_orders: "Track Pending Orders",
  track_pending_orders_desc:
    "See which orders are still open, which are delivered, and what’s due. This helps you manage your stock and cash flow more effectively.",
  please_select_start_end_date: "Please select start and end date",
  purchase_expense: "Purchase & Expense",
  send_invoices: "Send Invoices",
  sale_pos_desc:
    "With POS, you can quickly create a receipt, record payment, and hand it over to the customer right away. It’s fast, simple, and perfect for walk-in customers.",
  sale_invoices: "Sale Invoices",
  purchase_bill_desc:
    "Stop chasing suppliers over phone calls or messages. With Purchase Bill, you can send clear, professional requests for goods — with items, prices, and quantities all in one place.",
  expenses: "Expenses",
  expenses_description:
    "An Expenses help you record money spent on running your business — like rent, utilities, salaries, or supplies. It keeps all your business expenses properly documented.",
  create_purchase: "Create purchase",
  lost_in_your_expenses: "Lost in Your Expenses?",
  stay_organized: "Stay Organized",
  create_expense: "Create expense",
  avoid_missed_entries: "Avoid Missed Entries",
  avoid_missed_entries_desc:
    "Record expenses as soon as they happen to ensure nothing is forgotten and your accounts remain accurate.",
  track_all_business_costs: "Track All Business Costs",
  track_all_business_costs_desc:
    "Easily enter and save every expense, big or small, so you always know where your money is going.",
  summary_of_your_cash_out: "Summary of Your Cash Out",
  summary_of_your_cash_out_desc:
    "See exactly how much money has gone out of your business at a glance. With a proper expense summary, you always know where your cash is flowing and can plan smarter.",
  record_expense: "Record expense",
  expense_amount: "Expense amount",
  select_category: "Select category",
  paid_amount: "Paid amount",
  company: "Company",
  company_supplier: "Company / Supplier",
  total_paid_expenses: "Total paid expenses",
  total_unpaid_expenses: "Total unpaid expenses",
  expense_id: "Expense ID",
  options: "Options",
  expense_report: "Expense report",
  delete_expense: "Delete expense",
  are_you_sure_you_want_to_delete_this_expense:
    "Are you sure you want to delete this expense record?",
  expense_has_been_successfully_recorded:
    "Expense has been successfully recorded",
  expense_has_been_successfully_updated:
    "Expense has been successfully updated",
  companies: "Companies",
  search_by_expense_id: "Search by expense #",
  additional_details_subtitle: "(Notes, upload image and date)",
  additional_details_subtitle_stock:
    "(Barcode, Expiry, Batch number, Wholesale price, Manufacturing date)",
  discard_expense_btn: "Yes, discard this expense",
  this_action_cannot_be_undone: "This action cannot be undone.",
  Are_you_sure_you_want_to_change_the_customer_to_supplier:
    "Are you sure you want to change the customer to supplier?",
  Are_you_sure_you_want_to_change_the_supplier_to_customer:
    "Are you sure you want to change the supplier to customer?",
  Are_you_sure_you_want_to_delete_this_customer:
    "Are you sure you want to delete this customer?",
  are_you_sure_delete_suppier: "Are you sure you want to delete this supplier?",
  are_you_sure_delete_customer:
    "Are you sure you want to delete this customer?",
  save_to_draft_sales: "Save to draft sales",
  delete_draft: "Delete draft",
  delete_draft_desc: "Are you sure you want to delete this draft sale?",
  are_you_sure_you_want_to_delete_transaction:
    "Are you sure you want to delete the this transaction?",
  search_by_order: "Search order",
  no_filter_match:
    "No results match these filters. Try adjusting or clearing filters",
  item_name_placeholder: "e.g. Sugar",
  select_to_type_or_add: "Select to type or add",
  primary_unit: "Primary unit",
  stock_in_out: "Stock in / out",
  enter_number_to_send_reminder: "Enter number to send reminders",
  quantity_placeholder: "50",
  unit_placeholder: "e.g. Kg, Piece, Box",
  secondary_unit_placeholder: "e.g. Dozen, Carton",
  sell_rs_placeholder: "e.g. 120",
  cost_rs_placeholder: "e.g. 100",
  low_stock_alert_placeholder: "e.g. 10",
  enter_batch_number: "Enter batch number",
  clear_filters: "Clear filters",
  stock_in_updated: "Stock in updated",
  stock_out_updated: "Stock out updated",
  enter_or_create: "Enter or create",
  no_result_found: "No result found",
  edit_expenses: "Edit expenses",
  id: "ID",
  try_another_filter_to_find_what_youre_looking_for:
    "Try another filter to find what you’re looking for.",
  select_company_or_supplier: "Select company or supplier",
  avb_stock: "Avb stock",
  delete_pos: "Delete POS",
  are_you_sure_you_want_to_delete_this_pos:
    "Are you sure you want to delete this POS",
  create_stock_book: "Create stock book",
  low_stock_report_non_ideal_decs_half: "No low stock items found.",
  back_to_report: "Back to report",
  no_sales_data_found: "No sales data found",
  create_a_sale_to_generate_report: "Create a sale to generate report.",
  create_sale: "Create sale",
  start_making_sales_to_generate_reports:
    "Start making sales to generate reports",
  expense_search_description:
    "Try searching with another name or number to find what you are looking for",
  create_search_term_as_new_customer: "Create '{name}' as new customer",
  create_search_term_as_new_supplier: "Create '{name}' as new supplier",
  go_back_to_expense_listing: "GO BACK to expense listing",
  go_back_to_quick_sale_listing: "GO BACK to quick sale listing",
  remind_with_whatsapp_add_contact:
    "Please add a contact number to enable reminders via WhatsApp.",
  add_customer_to_sale: "Link a customer to share receipts quickly",
  create_your_own_item: "Create your own item",
  catalog_items: "Catalogue items",
  preview_image: "Preview image",
  go_back_to_POS: "Go back to POS listing",
  non_ideal_pos_book:
    "Try search the POS with another name to find what you’re looking for.",
  backup_data: "Backup data",
  available_balance: "Available balance",
  add_money: "Add Money",
  request: "Request",
  easyload_packages: "Easyload & packages",
  bill_payments: "Bill payments",
  vouchers: "Vouchers",
  shop: "Shop",
  sms_bundles: "SMS bundles",
  see_more_bills: "See more bills",
  sell_vouchers: "Sell vouchers",
  search_transactions: "Search transactions",
  transaction_id: "Transaction ID",
  scan_and_add_money_to_your_wallet: "Scan and add money to your RUPIN account",
  account_title: "Account title",
  IBAN: "IBAN",
  copy: "Copy",
  easy_QR_code_payments: "Easy QR code payments",
  share_details: "Share details",
  download_qr_code: "Download qr code",
  print_qr_code: "Print qr code",
  trusted_by_million_users: "Trusted by 5.3+ million users",
  licensed_by_State_Bank_of_Pakistan: "Licensed by State Bank of Pakistan",
  auto_reconciliation: "Auto reconciliation",
  send_anywhere: "Send anywhere",
  receive_anywhere: "Receive anywhere",
  free_and_instant: "Free & instant",
  your_account_just_got_an_upgrade: "Your account just got an upgrade.",
  it_only_takes_a_minute: "It only takes a minute",
  unlock_benefits_by_upgrading_your_account:
    "Unlock benefits by upgrading your account",
  licensed_by_sbp_in_principle: "Licensed by SBP (in principle)",
  upgrade_account: "Upgrade account",
  scan_qr_or_share_download_link: "Scan QR or share download link",
  copy_link: "Copy link",
  share_link: "Share link",
  upgrade_account_download_desc:
    "To upgrade your account, download the RUPIN App, scan the QR code, or copy and share the download link.",
  wallet_onboarding_b_slide1_title: "Har payment ke liye ek money",
  wallet_onboarding_b_slide1_subtitle: "Asaani se track aur manage karen",
  wallet_onboarding_b_slide2_title: "Pay karen kahin bhi, kabhi bhi",
  wallet_onboarding_b_slide2_subtitle: "Fast, free aur limitless transfer",
  wallet_onboarding_b_slide3_title: "Fori paise hasil karen. 100% free",
  wallet_onboarding_b_slide3_subtitle: "Na koi fees, na koi limit",
  pending_collections_payments: "Pending collections & payments",
  search_contact: "Search contact",
  contact: "Contact",
  document_no: "Document no",
  total_money_in: "Total money in",
  total_money_out: "Total money out",
  money_in: "Money in",
  money_out: "Money out",
  new_entry_in: "New entry (In)",
  new_entry_out: "New entry (Out)",
  view_all: "View all",
  choose_mobile_network: "Select network",
  recharge_type: "Recharge type",
  network_service_currently_unavailable: "This service is currently unavailable for {network}",
  enter_amount_rs: "Enter Amount Rs.",
  enter_amount_here: "Enter amount here",
  bank_name: "Bank name",
  account_details: "Account details",
  raast_id: "Raast ID",
  linked: "Linked",
  unlinked: "Not linked",
  link: "Link",
  linking: "Linking...",
  unlink: "Unlink",
  raast_id_unlink: "Unlink Raast ID",
  raast_id_unlink_desc: "Are you sure you want to unlink your Raast ID? You can link it again anytime.",
  raast_id_linked_successfully: "Raast ID linked successfully",
  raast_id_unlinked_successfully: "Raast ID unlinked successfully",
  enter_account_number_IBAN: "Enter account number / IBAN",
  enter_amount_rs: "Enter amount Rs.",
  enter_amount_here: "Enter amount here",
  insufficient_balance_please_try_different_amount:
    "Insufficient balance, please try different amount",
  go_to_wallet: "go to home",
  share_receipt: "share receipt",
  review: "Review",
  mobile_network_new: "Mobile network",
  select_customer: "Select customer",
  send_request: "Send request",
  pending_amount: "Pending amount",
  phone_number_already_exist:
    "Phone number already exist, please try different number",
  tired_of_payment_chaos: "Tired of payment chaos?",
  simplify_with_one_smart_wallet: "Simplify with one smart wallet.",
  let_get_started: "LEt’s get started",
  earn_money_on_every_transaction: "Earn money on every transaction",
  turn_every_recharge_the_more_you_earn:
    "Turn every recharge, bill payment, and voucher sale into extra income the more you sell, the more you earn.",
  track_every_transaction_effortlessly: "Track every transaction effortlessly",
  view_all_your_payments_stay_on_top_of_every_transaction:
    "View all your payments, Add Money, and send money in one place. Keep your business records organized and stay on top of every transaction.",
  send_money_anytime_anywhere: "Send money, anytime, anywhere",
  make_instant_payments_straight_without_delays_or_extra_steps:
    "Make instant payments straight from your wallet to any bank or wallet user. Fast, secure, and reliable, without delays or extra steps.",
  first_activate_your_wallet_in_3_easy_steps:
    "First activate your wallet in 3 easy steps",
  open_camera: "Open camera",
  and_scan_barcode: "and scan barcode",
  from_your_phone: "from your phone",
  udhaar_book_app_from: "Udhaar book app from ",
  play_store: "play store",
  tap_on_wallet_icon: "Tap on wallet icon",
  and_verify_KYC: "and verify KYC",
  download_app: "Download App",
  application_completed: "Application completed",
  application_ID: "Application ID",
  account_activation: "Account activation",
  your_account_will_be_activated_in: "Your account will be activated in",
  minutes: "minutes",
  select_package: "Select package",
  choose_package: "Choose package",
  hybrid: "Hybrid",
  data: "Data",
  social: "Social",
  mini: "Mini",
  search_package: "Search package",
  select: "Select",
  validity: "Validity",
  electricity: "Electricity",
  gas: "Gas",
  govt_fees: "Govt Fees",
  internet: "Internet",
  water: "Water",
  choose_bill_category: "Choose bill category",
  bill_organization_company: "Bill organization/company",
  eg_wapda: "e.g. WAPDA",
  type_scan_account_number: "Type or scan account number",
  enter_customer: "Enter customer",
  billing_organization: "Billing organization",
  consumer_num: "Consumer #",
  billing_month: "Billing month",
  bill_amount_after_due_date: "Bill amount after due date",
  select_voucher: "Select voucher",
  voucher: "Voucher",
  bills: "Bills",
  mobile_packages: "Mobile packages",
  total_easyload: "Total easyload",
  total_commission: "Total commission",
  total_bills_paid: "Total bills paid",
  total_vouchers_bought: "Total vouchers bought",
  all_transactions: "All transactions",
  nonIdealPendingCollectionSubtitle:
    "Easily collect money from friends and contacts right here. Once you send a request, it will appear in this list.",
  account_not_found_please_enter_valid_account_number_or_IBAN:
    "Account not found, please enter valid account number or IBAN",
  copied: "Copied",
  package_not_found: "Package not found",
  no_data_found: "No data found!",
  view_transactions: "View transactions",
  amount_range: "Amount range",
  no_transactions_found: "No transactions found",
  balance_insufficient: "Balance insufficient",
  your_sales_your_expenses_your_profit_crystal_clear:
    "Your sales, your expenses, your profit. Crystal clear.",
  send_invoices_collect_payments_easy_free:
    "Send invoices. Collect payments. Easy & Free",
  know_who_owes_remind_automatically_get_paid_3x_faster:
    "Know who owes. Remind automatically. Get paid 3x faster.",
  keep_stock_updated_never_miss_a_sale_sell_smarter:
    "Keep stock updated. Never miss a sale. Sell smarter",
  let_get_you_started: "Let's get you started",
  verify_your_otp: "Verify your OTP",
  select_contact: "Select contact",
  choose_voucher_type: "Choose voucher type",
  sell_voucher: "Sell voucher",
  voucher_details: "Voucher details",
  no_transactions_yet: "No transactions yet",
  Youll_see_your_all:
    "You’ll see your all money in and money out transaction history here",
  quicksale: "Quick sale",
  quick_sale_report: "Quick sale report",
  create_quick_sale: "Create quick sale",
  sale_amount: "Sale amount",
  edit_quicksale: "Edit quick sale",
  quickSale_has_been_successfully_updated:
    "Quick Sale has been successfully updated",
  quickSale_has_been_successfully_recorded:
    "Quick Sale has been successfully recorded",
  are_you_sure_you_want_to_delete_this_sale:
    "Are you sure you want to delete this sale record?",
  discard_quick_sale_btn: "Yes, discard this quick sale",
  total_paid_sales: "Total paid sales",
  total_unpaid_sales: "Total unpaid sales",
  search_by_sale_id: "Search by sale #",
  sale_id: "Sale ID",
  delete_sale: "Delete sale",
  lost_in_your_quickSales: "Lost in Your Sales?",
  OTP_verification_required: "OTP verification required",
  You_cant_leave_otp_verify_message:
    "You can’t leave this page without verifying the OTP.",
  sale_date_time: "Sale date & time",
  select_company_or_customer: "Select company or customer",
  customer_company: "Company / Customer ",
  recieved_amount: "Received amount",
  recieved: "Received",
  transaction_will_be_added_to_sales_and_contact:
    "Transaction will be added to sales and contact.",
  upload_attachment: "Upload attachment",
  collect_payment_via_QR_or_bank_transfer:
    "Collect payments via QR or bank transfer. 100% free",
  view_qr: "View QR",
  one_click_sale_faster_transaction: "One-click sales, faster transactions",
  speed_up_sales_reduce_wait_times:
    "Speed up sales, reduce wait times, and serve more contacts. Perfect for quick, everyday sales.",
  add_quick_sale: "Add quick sale",
  export: "Export",
  mark_as_paid: "Mark as paid",
  receipt: "receipt",
  quick_expense: "Quick expense",
  add_quick_expense: "Add quick expense",
  lost_in_expenses_stay_organized: "Lost in Your Expenses? Stay Organized",
  record_expense_as_soon_as:
    "Record expense as soon as they happen to ensure nothing is forgotten.",
  record_new_quick_sale: "Record new quick sale",
  download_bill: "Download bill",
  collect: "Collect",
  category_pl_tracking: "Category (P&L tracking)",
  select_sales_category: "Select sales category",
  scan_or_share_QR_to_collect_payment: "Scan or share QR to collect payment",
  get_qr: "Get QR",
  add_line_item: "Add line item",
  make_payment_with_bank_transfer:
    "Make payments with bank transfer. 100% free.",
  paid_on: "Paid on",
  unit_price: "Unit price",
  start_creating_your_first_sale_invoice:
    "Start creating your first sale invoice with easy steps",
  memo: "Memo",
  add_memo_here: "Add memo here",
  back: "Back",
  remaining_amount: "Remaining amount",
  received_amount: "Received amount",
  PO_number: "PO number",
  select_a_contact: "Select a contact",
  bank_account_details: "Bank account details",
  secure_100_free: "100% secure. 100% free.",
  ref_no: "Ref no.",
  are_you_sure_you_want_to_delete_invoice:
    "Are you sure you want to delete this invoice?",
  are_you_sure_you_want_to_delete_transaction:
    "Are you sure you want to delete this transaction?",
  start_your_account_by_adding_contact:
    "Start your accounts by adding a contact",
  account_help_you_track:
    "Accounts help you track who owes you money and whom you need to pay.",
  do_you_want_to_delete_associated_invoice:
    "Do you want to delete invoices associated to this contact?",
  add_transaction: "Add transaction",
  track_the_matter_of_you_took_money_or_gave_money:
    "Track the balance of you gave money or you took money from this contact.",
  payment_received: "Payment received",
  no_transactions_matching_those_filters:
    "No transactions matching those filters",
  try_adjusting_filters: "Try adjusting filters or",
  reset_small: "reset",
  you_wont_be_able_to_change_it_later: "You won’t be able to change it later.",
  account_settled: "Account settled",
  create_purchase_order: "Create purchase order",
  purchase_order: "Purchase order",
  start_creating_your_fist_purchase_order_with_easy_steps:
    "Start creating your first purchase order with easy steps",
  download_po: "Download PO",
  PO_no: "PO no",
  edit_purchase_order: "Edit purchase order",
  add_notes_here: "Add notes here",
  notes: "Notes",
  reference_number: "reference number",
  accept_payments_into_your_bank_account:
    "Accept payments into your bank account",
  add_signature_on_invoice: "Add signature on invoice",
  get_your_bank_details: "Get your bank details",
  overdue: "Overdue",
  outstanding: "بقايا",
  type_signature: "Type signature",
  activate_wallet: "Activate wallet",
  wholesale: "Wholesale",
  batchAndExpiry: "Batch & expiry",
  no_customers_yet: "No customers yet",
  you_have_not_added_any_customer: "You haven’t added any customers. Add customers to track money you will receive.",
  no_suppliers_yet: "No suppliers yet",
  add_suppliers_to_track_payments: "Add suppliers to track payments you need to make.",
  no_transactions_for_others_yet: "No transactions from others yet",
  when_someone_record_a_transaction_using_your_contact_details: "When someone records a transaction using your contact details, it will appear here automatically.",
  upload_stock_items: "Upload your file or download the template for help formatting your items",
  items_imported: "آئٽم درآمد ٿي ويا",
  bulk_upload: "بلڪ اپلوڊ",
  create_search_term_as_new_contact: "Create '{name}' as new contact",
  inventory_management: "Inventory management",
  create_items_in_easy_steps_and_manage_inventory: "Create item in easy steps and manage inventory.",
  sell_price: "Sell price",
  current_qty: "Current qty",
  stock_in_qty: "Stock in qty",
  stock_out_qty: "Stock out qty",
  units_sold: "Units sold",
  total_cost: "Total cost",
  see_more: "See more",
  no_stock_history_yet: "No stock history yet",
  stock_changes_will_appear_here_one_you_start_adding: "Stock changes will appear here once you start adding or updating items.",
  transaction_added_by_this_contact_will_appear_here_automatically: "Transactions added by this contact will appear here automatically.",
  quick_sale: "Quick sale",
  sale_invoice: "Sale invoice",
  all_your_sales_in_one_place: "All your sales in one place",
  manage_all_your_quick_sale_invoices_and_pos_transactions: "Manage all your Quick Sales, Invoices, and POS transactions together in one unified list.",
  businessoverview: "Business overview",
  add_expense: "add expense",
  Add_salesexpenses_to_see_your_PL_and_grow_your_profits: "Add sales & expenses to see your P&L and grow your profits.",
  viewPAndL: "view p&l",
  add_stock: "Add stock",
  sale_has_been_successfully_updated: "Sale has been successfully updated.",
  profit_Loss: "Profit & Loss",
  cash_flow: "Cash flow",
  total_cost_value: "Total cost value",
  cash_Bank: "Cash & Bank",
  total_item_in_stock: "Total items in stock",
  low_stock_items: "Low stock items",
  receivables: "Receivables",
  payables: "Payables",
  see_details: "See details",
  too_many_walk_ins_keep_them_smooth_with_pos: "Too many walk-ins? Keep them smooth with POS",
  start_pos: "start pos",
  profit_Loss_statement: "Profit & Loss statement",
  cost_of_sales: "Cost of sales",
  gross_profit: "Gross profit",
  categories: "Categories",
  see_less: "See less",
  recent_transactions: "Recent transactions",
  gross_cash_inflow: "Gross cash inflow",
  gross_cash_outflow: "Gross cash outflow",
  net_cash_change: "Net cash change",
  change_category: "Change category",
  sales_category: "Sales category",
  category_updated: "Category updated",
  organize_your_expenses: "Organize your expenses",
  organize_your_sales: "Organize your sales",
  manage_your_Saddar_store_inventory_and_look_after_the_payments: "Manage your Saddar store inventory and look after the payments.",
  contact_attached_successfully: "Contact attached successfully",
  debit: "Debit",
  no_ledger_matching_those_filters: "No ledger matching those filters",
  clear_all_items: "Clear all items",
  add_to_sale: "Add to sale",
  search_by_customer_name_or_sale_id: "Search by customer name or order no",
  order_number: "Order number",
  Variation: "Variation",
  create_item_in_easy_steps_and_manage_stock: "Create item in easy steps and manage stock.",
  mark_in_stock: "Mark in stock",
  mark_out_of_stock: "Mark out of stock",
  change_language: "Change language",
  select_language: "Select language",
  change_appearance: "Change appearance",
  select_theme: "Select theme",
  light_mode: "Light mode",
  dark_mode: "Dark mode",
  delete_business: "Delete business",
  edit_profile: "Edit profile",
  confirmation: "Confirmation",
  no_order_matching_those_filters: "No order matching those filters",
  pin: "Pin",
  it_ensure_that_no_one_else_can_access: "It ensures that no one else can access your account",
  create_your_new_pin: "Create new PIN",
  confirm_your_new_pin: "Confirm PIN",
  enter_current_pin: "Enter current PIN",
  please_enter_your_4_digits_PIN_to_contine: "Please enter your 4 digits PIN to contine",
  your_accounts_first_line_of_defence_make_sure_its_unique: "Your account’s first line of defence. Make sure it’s unique and hard to guess.",
  pin_updated_successfully: "PIN updated successfully",
  profile_updated: "Profile updated",
  business_created: "Business created",
  create_business: "Create business",
  variant_image: "Variant image",
  view: "View",
  setup_your_printer: "Setup your printer",
  download_applications: "Download applications",
  printer_selection: "Printer selection",
  test_printer: "Test printer",
  to_setup_printer_download_java: "To setup printer, download & install Java",
  download_java: "Download Java",
  watch_video_for_help: "Watch video for help",
  need_help_contact: "Need help? +92 341 1141000",
  test_selected_printer: "Test selected printer",
  printer_setup_successfully: "Printer setup successfully",
  proceed: "Proceed",
  select_printer: "Select printer",
  printers: "Printers",
  add_another_printer: "Add another printer",
  printer_name: "Printer name",
  connected: "Connected",
  not_connected: "Not connected",
  connect: "Connect",
  disconnect: "Disconnect",
  is_java_application_successfully_installed: "Is Java application successfully installed?",
  is_printer_software_successfully_installed: "Is printer software successfully installed?",
  is_printer_software_drivers_successfully_installed: "Is printer software drivers successfully installed?",
  is_printer_test_successful: "Is printer test successful?",
  please_select_a_printer: "Please select a printer",
  failed_to_connect_printer_please_try_again: "Failed to connect printer. Please try again.",
  download_and_install_printer_software: "Download & install printer software",
  download_and_install_drivers: "Download & install drivers",
  download_software: "Download Software",
  download_drivers: "Download Drivers",
  test_print: "Test Print",
  need_help: "Need help?",
  chat_with_us: "Chat with us",
  upload: "Upload",
  your_data_backup_is_up_to_date: "Your data backup is up to date",
  your_data_backup_is_not_up_to_date: "Your data backup is not up to date",
  error: "Error",
  enter_your_business_details: "Enter business details",
  enter_your_business_name: "Enter your business name",
  create_and_send_invoices: "Create and send invoices",
  create_send_and_track_invoices_Get_paid_faster: "Create, send and track invoices. Get paid faster.",
  manage_your_accounts: "Manage your accounts",
  track_money_in_and_out_Faster_collections_100reliable: "Track money in and out. Faster collections. 100% reliable.",
  collect_send_and_earn_money: "Collect, send, and earn money",
  your_trusted_wallet_100_secure_completely_free: "Your trusted wallet. 100% secure. Completely free.",
  stock_quantity: "Stock quantity",
  skip: "Skip",
  what_would_you_like_to_start: "How would you like to start?",
  scan_download_app: "Scan & Download App",
  select_unit_type: "Select unit type",
  sr_no: "Sr no.",
  backup_your_data: "Backup your data",
  no_option: "No option",
  is_your_printer_not_in_the_list: "Is your printer not present in the list? Install Java, the printer software, and the printer driver, then click on",
  log_out: "Log out",
  loss: "Loss",
  net_loss: "Net loss",
  no_uncategorized_transactions: "No uncategorized transaction",
  all_sales_and_expenses_are_categorized: "All expense and sales are categorized. Great job keeping things organized!",
  create_an_account: "Create an account",
  login_to_rupin: "Login to RUPIN",
  log_in: "Log in",
  welcome_to: "Welcome to",
  change_phone_number: "Change phone number",
  advance_paid: "Advance paid",
  you_are_currently_offline: "You’re currently offline",
  please_check_your_internet_connection_and_try_again: "Please check your internet connection and try again.",
  send_code: "send code",
  verify_captcha: "Verify captcha",
  too_many_incorrect_attempts: "Too many incorrect PIN attempts",
  pin_entry_has_been_temporarily_locked_after_3_incorrect_attempts: "For your security, PIN entry has been temporarily locked after 3 incorrect attempts.",
  Youve_reached_the_8_transactions_limit: "You’ve reached the 8 transactions limit. Verify your phone number to continue using RUPIN securely.",
  You_reached_your_limit: "You’ve reached your limit",
  payment_received_added: "Payment received added",
  unified_view_of_quick_sale_invoice_and_pos: "Unified view of quick sale, invoice, and POS",
  account_locked: "Account locked",
  expense_category: "Expense category",
  select_expense_category: "Select expense category",
  select_due_date: "Select due date",
  start_typing_to_create_one: "Start typing to create one",
  select_purchase_category: "Select purchase category",
  add_signature_on_purchase_order: "Add signature on purchase order",
  purchase_no: "Purchase no",
  unsupported_file_format: "Unsupported file format",
  this_customer_entry_will_be_transferred_to_the_supplier_section: "This customer's entry will be transferred to the supplier section.",
  this_supplier_entry_will_be_transferred_to_the_customer_section: "This supplier's entry will be transferred to the customer section.",
  we_need_your_current_pin_to_proceed: "We need your current PIN to proceed.",
  profits: "Profits",
  profit_Loss_statement: "Profit & Loss statement",
  net_cash: "Net cash",
  account_temporarily_locked: "Account temporarily locked",
  invoice_created_with_rupin: "Invoice created with RUPIN",
  po_created_with_rupin: "PO created with RUPIN",
  go_to_listing: "Go to listing",
  invoice_details: "Invoice details",
  purchase_order_details: "Purchase order details",
  record_new_quick_expense: "Record new quick expense",
  account_temporarily_locked_OTP_desc: "For your security, this account has been temporarily locked after multiple incorrect OTP attempts.To regain access, please contact us",
  account_temporarily_locked_PIN_desc: "For your security, this account has been temporarily locked after multiple incorrect PIN attempts.To regain access, verify your identity using the Udhaar Book app.",
  order_saved_into_draft_sales: "Order saved into draft sales",
  add_contact_and_items_to_send_money: "Add contact and items to send money",
  amount_required_to_send_money: "Amount is required to send money",
  go_to_home: "Go to home",
  the_page_you_are_looking_for_may_be_moved_or_deleted: "The page you're looking for may have been moved or deleted.",
  item_image: "Item image",
  money: "Money",
  report_download_is_not_available_yet: "Report download is not available yet.",
  something_went_wrong: "Something went wrong",
  PIN_is_required: "PIN is required.",
  you_cannot_leave_this_page_without_creating_a_PIN: "You cannot leave this page without creating a PIN.",
  update_item_price: "Update item price",
  udhaar_book_is_now_rupin: "Udhaar Book is now Rupin.",
  migration_upgrade_subtitle: "We upgraded. Your account stays exactly the same.",
  migration_account_safe: "Your account is safe",
  migration_data_secure: "All data is secure",
  migration_transaction_intact: "Transaction history intact",
  migration_business_records_unchanged: "Business records unchanged",
  continue_to_rupin: "Continue to Rupin",
  rupin_migration_banner_message:
    "Udhaar Book is now Rupin. Everything safe, new features coming, all free.",
  no_vouchers: "No vouchers",
  no_bill_category: "No bill category",
  no_vouchers_available: "No vouchers available",
  there_are_no_vouchers_available_at_the_moment: "There are no vouchers available at the moment. Once vouchers become available, they will appear here.",
  are_you_sure_you_want_to_logout_all_data_will_be_lost: "Are you sure you want to log out? All data will be lost.",
  view_statement: "View statement",
  incoming_this_month: "Incoming this month",
  outgoing_this_month: "Outgoing this month",
  pay_bills: "pay bills",
  account_limit: "Account limit",
  increase_limit: "Increase limit",
  total_limit: "Total limit",
  remaining: "Remaining",
  used: "Used",
  resets_on: "Resets on",
  upload_electricity_or_gas_bill_to_increase_limit: "Upload electricity or gas bill to increase limit",
  upload_bill: "Upload bill",
  ntn_number: "NTN number",
  enter_ntn_number: "Enter NTN number",
  ntn_number_length: "NTN number should be between 7 and 13 digits",
  something_went_wrong_please_try_again: "Something went wrong please try again",
  limit_increase_is_in_process: "Limit increase is in process",
  limit_increase_is_in_process_subtitle: "Thank you for submitting required details, we’ll contact you.",
  share_qr: "Share QR",
  get_paid_faster: "Get paid faster",
  get_paid_faster_subtitle: "Start accepting payments with digital invoices",
  pay_bills: "Pay bills",
  enter_iban_account_raastid_name_or_phone : "Enter IBAN, Account #, Raast ID, Name or Phone #",
  select_start_bank : "Select the bank",
  no_banks_found: "No banks found",
  print_qr: "Print QR",
  download_qr: "Download QR",
  limit_increase_request_in_process_need_help: "Limit increase request in process. Need help?  Chat with us",
  refund: "Refund",
  select_bill_category : "Select bill category",
  consumer_number : "Consumer number",
  scan_barcode : "Scan barcode",
  results : "Results",
  last_paid : "Last paid",
  select_bill : "Select bill",
  search_bill_by_name : "Search bill by name",
  no_bills_found: "No bills found",
  due : "Due",
  you_will_earn : "You will earn",
  points : "points",
  bill_paid_with   : "Bill paid with",
  rupin : "RUPIN",
  bill_paid_with_rupin : "Bill paid with RUPIN",
  easyload_done_with : "Easyload done with",
  easyload_done_with_rupin : "Easyload done with RUPIN",
  confirm_payment : "Confirm payment",
  failed_to_copy : "Failed to copy",
  money_sent_with : "Money sent with",
  money_received: "Money received",
  money_sent: "Money sent",
  bundle_recharge: "Easyload package",
  mins: "mins",
  other_net_mins: "Other net mins",
  all_net_sms: "All net SMS",
  money_sent_to : "Money sent to",
  money_sent_with_rupin : "Money sent with RUPIN",
  voucher_company : "Voucher company",
  select_voucher_company : "Select voucher company",
  search_voucher_by_name : "Search voucher by name",
  no_voucher_found : "No voucher found",
  recent: "تازو",
  no_results_enter_complete_account_or_iban: "ڪوئي نتيجو نه، مڪمل اڪائونٽ نمبر يا IBAN داخل ڪريو",
  top_up_account_to_complete_transaction: "هن ٽرانزيڪشن کي مڪمل ڪرڻ لاءِ پنهنجي اڪائونٽ ۾ پئسا شامل ڪريو۔",
  search_bank: "بينڪ ڳولھيو",
  error_in_send_money: "پئسا موڪلڻ ۾ غلطي",
  transaction_failed: "ٽرانزيڪشن ناڪام",
  your_account_has_been_locked: "توهانجو اڪائونٽ لاک ٿي ويو آهي",
  tid: "TID",
  by: "ذريعي",
  fee_free: "(مفت)",
  fast_secure_payment_in: "تيز، محفوظ ادائيگي ",
  view_receipt: "رسيد ڏسو",
  copy_receipt: "Copy receipt",
  network_type: "Network type",
  could_not_load_qr : "Could not load QR details. Please try again.",
  package_name: "Package name",
  bank_statement: "Bank statement",
  last_3_months: "Last 3 months",
  last_6_months: "Last 6 months",
  last_12_months: "Last 12 months",
  request_placed: "Request placed",
  downloading_statement: "Downloading statement...",
  duration: "Duration",
  easypaisa_tab: "Easypaisa",
  jazzcash_tab: "Jazzcash",
  searching: "Searching",
  weak_pin_choose_something_else: "Weak PIN. Choose something else",
  first_create_your_pin: "First create your PIN",
  others: "Others",
  add_first_transaction_for_name: "{name} جو پهريون حساب ڪتاب لکو",
  invoice_sale: "Invoice sale",
  attachment: "Attachment",
  paid_transactions_cannot_be_edited: "Paid transactions cannot be edited.",
  cash_book: "Cash Book",
  enter_product_name: "Enter product name",
  enter_stock: "Enter stock",
  enter_low_stock: "Enter low stock",
  enter_sell_price: "Enter sell price",
  enter_barcode: "Enter barcode",
  enter_wholesale_price: "Enter wholesale price",
  enter_value: "Enter value",
  quick_item_save: "Save",
  quick_item_cancel: "Cancel",
  bulk_upload_invalid_item_name: "Invalid item name. Use letters, numbers, spaces, - or _ only.",
  bulk_upload_item_name_missing: "Item name is not filled in the CSV template.",
  custom_date_range: "Custom date range",
  custom_statements: "Custom statements",
  statement_generation_started: "Your statement is being generated. You can find it in View statements.",
  no_available_statements: "No available statements",
  no_available_statements_subtitle: "Your  bank statements will appear here once available",
  in_progress: "In process",
  cashback_on_easyload : "Cashback on easyload",
  are_you_sure_you_want_to_delete_statement: "Are you sure you want to delete statement",
  channel: "Channel",
  avg_order_value: "Avg. Order value",
  contribution: "Contribution",
  total_collected: "Total collected",
  percentage: "Percentage",
  items_sold: "Items sold",
  gross_sales: "Gross sales",
  net_sales: "Net sales",
  last_sold: "Last sold",
  current_stock: "Current stock",
  cost: "Cost",
  profit_margin: "Profit margin",
  average_unit_price: "Average unit price",
  average_expense: "Average expense",
  last_purchased: "Last purchased",
  activate_account: "Activate account",
  activate_now: "Activate now",
  add_money_from_any_bank_free: "Add money from any bank. 100 Free.",
  add_money_from_easypaisa: "Add money from Easypaisa",
  easypaisa_step_see_all: "Click on 'See all'",
  easypaisa_step_fee_collection: "Select 'Fee collection'",
  easypaisa_step_search_rupin: "Search and select 'Rupin'",
  easypaisa_step_enter_consumer_id: "Enter consumer ID",
  instruction_for_adding_money : "Instructions for adding money",
  getQR : "Get QR",
  enter_amount : "Enter amount",
  processing_limit_increase_contact_you: "Processing limit increase. We’ll contact you",
  view_yearly_data: "view yearly data",
  no_data_yet : "No data yet",
  it_looks_like_you_dont_have_any_data_yet: "It looks like you haven't made any transactions yet.",
  start_new_sale: "Start new sale",
  sales_summary : "Sales summary",
  discount_summary : "Discount summary",
  expense_by_category : "Expense by category",
  low_selling_items : "Low selling items",
  profit_margin : "Profit margins",
  sales_by_category : "Sales by category",
  sales_by_payment_method : "Sales by payment method",
  tax_summary : "Tax summary",
  top_contacts_by_sale : "Top contacts by sale",
  top_selling_items : "Top selling items",
  total_sales_by_channel : "Total sales by channel",
  track_every_rupee: "Track every rupee",
  record_daily_cash_in_and_cash_out : "Record daily cash in and cash out.",
  add_category_to_track_PAndL: "add category to track P&L",
  no_vouchers_available : "No vouchers available",
  there_are_no_vouchers_available_at_the_moment : "There are no vouchers available at the moment. Once vouchers become available, they will appear here.",
  are_you_sure_you_want_to_logout_all_data_will_be_lost : "Are you sure you want to log out? All data will be lost.",
  confirm_payment: "ادائيگي جي تصديق",
  incorrect_reference_number: "غلط ريفرنس نمبر",
  bill_image_will_appear_here: "بل جي تصوير هتي ظاهر ٿيندي",
  reference_no: "ريفرنس نمبر",
  account_no: "اڪائونٽ نمبر",
  customer_id: "ڪسٽمر آءِ ڊي",
  instantly_check_your_bill: "Instantly check your bill",  
  enter_bill_details_below: "Enter bill details below to view and pay your bill",  
  search_bill: "بل ڳوليو",
  powered_by_nadra: "نادرا جي مدد سان",
  licensed_by_sbp_in_principle: "ايس بي پي کان لائسنس يافته (اصولي طور تي)",
  trusted_by_5_3_million_users: "5.3 ملين کان وڌيڪ استعمال ڪندڙن جو اعتماد",
  select_biller: "بلر چونڊيو",
  your: "توهان جو",
  check_pay_bills_with_rupin: "روپن سان بل چيڪ ۽ ادا ڪريو",
  visibility: "Visibility",
  published: "Published",
  by_others: "By others",
  method: "Method",
  newest: "Newest",
  oldest: "Oldest",
  amount_high_to_low: "Amount (High to Low)",
  amount_low_to_high: "Amount (Low to High)",
  search: "Search",
  name_z_a: "نام (Z-A)",
  quantity_high_to_low: "Quantity (High to Low)",
  quantity_low_to_high: "Quantity (Low to High)",
  end: "End",
  keyword: "Keyword",

  minimum_amount: "گھٽ ۾ گھٽ رقم",
  maximum_amount: "وڌ ۾ وڌ رقم",
  search_by_contact: "رابطي سان ڳوليو",
  search_by_contact_or_order_no: "رابطي يا آرڊر نمبر سان ڳوليو",
  search_by_contact_or_invoice_no: "رابطي يا انوائس نمبر سان ڳوليو",
  invalid_number: "غلط نمبر",
  cannot_be_negative: "منفي نه ٿي سگهي",
  cannot_be_negative_or_zero: "منفي يا صفر نه ٿي سگهي",
  max_should_be_greater_than_min: "وڌ ۾ وڌ، گھٽ ۾ گھٽ کان وڌيڪ هجڻ گھرجي",
  thirty_days: "30 ڏينهن",
  half_yearly: "6 مهينا",

  fill_in_your_data: "پنو ڊيٽا ڀريو",
  upload_the_file: "فائل اپلوڊ ڪريو",
  csv_xls_files_supported: "(.csv ۽ .xls فائلن جي حمايت ڪئي وئي آهي)",
  invalid_file_format_csv_xls: "غلط فائل فارميٽ. مهرباني ڪري .csv، .xls، يا .xlsx فائل اپلوڊ ڪريو.",
  file_uploaded: "فائل اپلوڊ ٿي وئي",
  finished: "مڪمل",
  entries_imported_successfully: "داخلائون ڪاميابيءَ سان درآمد ٿيون.",
  entries_failed: "داخلائون ناڪام ٿيون",
  item_discount: "آئٽم ڊسڪائونٽ",
  remove_item: "آئٽم ڪڍي ڇڏيو",
  transaction_details: "ٽرانزيڪشن جي تفصيل",

  scan_and_pay: "اسڪين ۽ ادائگي",
  total_balance_due: "ڪل واجب الادا رقم",
  scan_qr: "QR اسڪين ڪريو",
  bank_transfer: "بينڪ ٽرانسفر",
  transfer_to_this_iban: "هن IBAN تي ٽرانسفر ڪريو",
  transfer_exact_amount_shown_above: "مٿي ڏيکاريل صحيح رقم ٽرانسفر ڪريو",
  how_to_pay: "ادائگي جو طريقو",
  scan_step_1: "پنهنجي بينڪنگ ايپ يا والٽ کوليو ۽ مٿي ڏنل QR ڪوڊ اسڪين ڪريو.",
  scan_step_2: "رقم Rs. {amount} جي تصديق ڪريو ۽ ٽرانسفر ڪريو",
  scan_step_3: "Pay تي ڪلڪ ڪريو.",
  bank_step_1: "پنهنجي بينڪنگ ايپ يا والٽ کوليو",
  bank_step_2: "مٿي ڏنل IBAN تي صحيح رقم Rs. {amount} ٽرانسفر ڪريو",
  bank_step_3: "Pay تي ڪلڪ ڪريو.",
  payment_confirmation_sms_note: "توهان کي پنهنجي SMS تي ادائگي جي تصديق ۽ ٽرانزيڪشن ID ملي ويندي",
  verify_payment: "ادائگي جي تصديق ڪريو",
  bill_payment_to: "بل جي ادائگي بنام",
  reports : "Reports",
  payment_mode : "Payment mode",
  contact_support : "Contact support",
};
